{
  "LOGIN": {
    "TITLE": "Bentornato",
    "SUBTITLE": "Inserisci le tue credenziali per accedere al tuo account",
    "EMAIL_PLACEHOLDER": "tuo@esempio.com",
    "PASSWORD_LABEL": "Password",
    "SUBMIT": "Accedi",
    "SUBMITTING": "Accesso in corso...",
    "QUICK_LOGIN": "Accesso rapido",
    "QUICK_SUPER_ADMIN": "Super Admin",
    "QUICK_ADMIN": "Admin",
    "FORGOT_PASSWORD": "Password dimenticata?"
  },

  "FORGOT_PASSWORD": {
    "TITLE": "Reimposta password",
    "SUBTITLE": "Inserisci la tua email e ti invieremo le istruzioni",
    "CHECK_INBOX": "Controlla la tua casella di posta",
    "EMAIL_SENT": "Abbiamo inviato un link di recupero alla tua email",
    "EMAIL_LABEL": "Indirizzo Email",
    "EMAIL_PLACEHOLDER": "nome@azienda.com",
    "SEND_INSTRUCTIONS": "Invia istruzioni",
    "SENDING": "Invio in corso...",
    "SENT_TO": "Inviato a",
    "CHECK_SPAM": "Non hai ricevuto l'email? Controlla la cartella spam o riprova.",
    "TRY_ANOTHER_EMAIL": "Prova con un'altra email",
    "BACK_TO_LOGIN": "Torna al login"
  },

  "MOBILE": {
    "HUB_TITLE": "Welty",
    "HUB_SCREEN_TITLE": "Inizio",
    "BACK": "Indietro"
  },

  "PWA_INSTALL": {
    "BANNER_LABEL": "Installa app",
    "TITLE": "Installa Welty sul telefono",
    "ANDROID_HINT": "Aggiungi Welty alla schermata Home per un accesso più veloce.",
    "ANDROID_MANUAL": "Apri il menu del browser (⋮), poi tocca «Installa app» o «Aggiungi a schermata Home». In sviluppo su rete Wi‑Fi il pulsante automatico può non comparire: usa «Aggiungi a schermata Home» dal menu.",
    "IOS_INSTRUCTIONS": "Tocca Condividi, poi scegli «Aggiungi a Home».",
    "INSTALL": "Installa",
    "LATER": "Non ora"
  },

  "COMMON": {
    "LOGOUT": "Esci",
    "ACTIONS": "Azioni",
    "LOADING": "Caricamento...",
    "SAVING": "Salvataggio...",
    "SELECT_PLACEHOLDER": "Seleziona...",
    "PER_PAGE": "per pagina",
    "PREV": "Prec",
    "NEXT": "Succ",
    "NO_DATA": "Nessun dato",
    "CANCEL": "Annulla",
    "ERROR": "Errore",
    "EDIT": "Modifica",
    "CLOSE": "Chiudi",
    "SAVE": "Salva",
    "SAVE_SUCCESS": "Salvato con successo.",
    "CREATE_SUCCESS": "Creato con successo.",
    "UPDATE_SUCCESS": "Aggiornato con successo.",
    "DELETE_SUCCESS": "Eliminato con successo.",
    "COPIED": "Copiato negli appunti.",
    "COPY_FAILED": "Impossibile copiare."
  },

  "CONFIRM_MODAL": {
    "CONFIRM": "Conferma",
    "CANCEL": "Annulla",
    "DELETE": "Elimina"
  },

  "ADMIN": {
    "OVERVIEW": "Panoramica",
    "TENANTS": "Tenant",
    "ACCOUNT": "Account",
    "SHOWCASE": "Showcase",
    "TENANT_BLOCK_CONFIRM_TITLE": "Conferma blocco",
    "TENANT_BLOCK_CONFIRM_MESSAGE": "Sei sicuro di voler bloccare questo tenant?\n<strong>{{name}}</strong>",
    "TENANT_UNBLOCK_CONFIRM_TITLE": "Conferma sblocco",
    "TENANT_UNBLOCK_CONFIRM_MESSAGE": "Sei sicuro di voler sbloccare questo tenant?\n<strong>{{name}}</strong>",
    "TENANT_REMOVE_USER_CONFIRM_TITLE": "Conferma rimozione",
    "TENANT_REMOVE_USER_CONFIRM_MESSAGE": "Sei sicuro di voler rimuovere questo utente dal tenant?\n<strong>{{name}}</strong>",
    "TENANT_INVITE_DELETE_CONFIRM_TITLE": "Annulla invito",
    "TENANT_INVITE_DELETE_CONFIRM_MESSAGE": "Sei sicuro di voler annullare questo invito?\n<strong>{{email}}</strong>",
    "TENANT_INVITE_RENEW_CONFIRM_TITLE": "Rinnova invito",
    "TENANT_INVITE_RENEW_CONFIRM_MESSAGE": "Sei sicuro di voler rinnovare l'invito?\n<strong>{{email}}</strong>",
    "TENANT_INVITE_RESEND_CONFIRM_TITLE": "Reinvia invito",
    "TENANT_INVITE_RESEND_CONFIRM_MESSAGE": "Sei sicuro di voler reinviare l'invito?\n<strong>{{email}}</strong>",
    "USER_ROLE_UPDATE_ERROR": "Impossibile aggiornare il ruolo utente.",
    "INVITES_LOAD_FAILED": "Impossibile caricare gli inviti.",
    "INVITE_CREATE_FAILED": "Impossibile creare l'invito.",
    "INVITE_RENEW_FAILED": "Impossibile rinnovare l'invito.",
    "INVITE_RESEND_FAILED": "Impossibile reinviare l'invito.",
    "INVITE_DELETE_FAILED": "Impossibile annullare l'invito.",
    "INVITE_RENEWED_SUCCESS": "Invito rinnovato. È stata inviata una nuova email.",
    "INVITE_RESENT_SUCCESS": "Invito reinviato correttamente.",
    "SUPER_ADMIN_INVITE_FAILED": "Impossibile inviare l'invito.",
    "WHATSAPP": {
      "TITLE": "WhatsApp / Twilio",
      "SYNC_TWILIO": "Sincronizza numeri da Twilio",
      "PENDING_REQUESTS": "Richieste di connessione in attesa",
      "NO_PENDING": "Nessuna richiesta in attesa.",
      "COL_TENANT": "Tenant",
      "COL_NUMBER": "Assegna numero",
      "COL_ASSIGNED": "Tenant assegnato",
      "COL_E164": "E.164",
      "COL_SID": "SID",
      "USAGE_CATEGORY": "Categoria",
      "USAGE_COUNT": "Conteggio",
      "USAGE_PRICE": "Prezzo",
      "SELECT_NUMBER": "Seleziona un numero…",
      "APPROVE": "Approva",
      "REJECT": "Rifiuta",
      "NO_INVENTORY": "Nessun numero in inventario. Sincronizza da Twilio per caricarli.",
      "INVENTORY": "Inventario numeri",
      "USAGE": "Utilizzo (Twilio)",
      "COL_ACTIONS": "Azioni",
      "DISCONNECT": "Disconnetti",
      "DISCONNECT_CONFIRM": "Disconnettere WhatsApp per il tenant che usa {{e164}}? Il numero tornerà disponibile per un'altra assegnazione.",
      "DISCONNECT_SUCCESS": "WhatsApp disconnesso. Il numero è di nuovo disponibile.",
      "DISCONNECT_ERROR": "Impossibile disconnettere WhatsApp per questo tenant."
    }
  },

  "NAV": {
    "DASHBOARD": "Dashboard",
    "CONVERSATIONS": "Conversazioni",
    "NOTIFICATIONS": "Notifiche",
    "CONTACTS": "Contatti",
    "KNOWLEDGE_BASE": "Knowledge Base",
    "FLOWS": "Flussi",
    "SERVICES": "Servizi",
    "APPOINTMENTS": "Appuntamenti",
    "COLLABORATORS": "Collaboratori",
    "INSIGHTS": "Insights",
    "FLOOR_PLAN": "Planimetria",
    "FLOOR_PLAN_LIVE": "Sala (live)",
    "FLOOR_PLAN_ANALYTICS": "Analytics sala",
    "FOOD_SETTINGS": "Impostazioni ristorante",
    "SETTINGS": "Impostazioni",
    "SECTION_FOOD": "Food service",
    "SECTION_PERSONAL_CARE": "Assistenza alla persona"
  },

  "FOOD_SETTINGS": {
    "TITLE": "Impostazioni ristorante e prenotazioni",
    "SUBTITLE": "Gli orari valgono per prenotazioni via chat e in sala live. Ogni giorno è in UTC (come le date operative).",
    "HERO_EYEBROW": "Food · Prenotazioni",
    "LOADING": "Caricamento…",
    "SAVE": "Salva",
    "SAVE_SUCCESS": "Impostazioni ristorante salvate.",
    "ERROR_LOAD": "Impossibile caricare le impostazioni ristorante.",
    "ERROR_SAVE": "Impossibile salvare le impostazioni ristorante.",
    "INVALID_DAY_HOURS": "Uno o più orari non sono validi. Usa orari 24h (ore 00–23, minuti 00–59).",
    "MISSING_DAY_HOURS": "Imposta apertura e chiusura per ogni giorno aperto.",
    "MISSING_DAY_INTERVALS": "Ogni giorno aperto richiede almeno una fascia con orario di apertura e chiusura.",
    "CLOSE_NOT_AFTER_OPEN": "La chiusura deve essere dopo l’apertura nello stesso giorno solare, oppure usa una fascia notturna (chiusura prima dell’apertura in orologio, es. 22:00–02:00).",
    "SAME_OPEN_CLOSE": "Apertura e chiusura non possono coincidere.",
    "OVERNIGHT_LIMIT": "È consentita al massimo una fascia notturna al giorno (es. 22:00–02:00).",
    "OVERLAPPING_INTERVALS": "Le fasce dello stesso giorno non possono sovrapporsi.",
    "ADD_INTERVAL": "Aggiungi fascia oraria",
    "REMOVE_INTERVAL_ARIA": "Rimuovi questa fascia oraria",
    "INVALID_WEEKLY_SHAPE": "I dati degli orari settimanali sono incompleti. Ricarica la pagina e riprova.",
    "AT_LEAST_ONE_OPEN_DAY": "Lascia almeno un giorno aperto.",
    "SECTION_WEEKLY_HOURS": "Orari per giorno",
    "HINT_WEEKLY_UTC": "Per ogni giorno puoi impostare una o più aperture/chiusure (es. pranzo e cena) oppure segna chiuso. La settimana è domenica–sabato in UTC. Orario di chiusura 00:00 = mezzanotte fine giornata (non l’inizio del giorno dopo). Per servizio notturno vero (es. 22:00–02:00) usa una chiusura dopo le 00:01.",
    "CLOSED": "Chiuso",
    "OPENS": "Apre",
    "CLOSES": "Chiude",
    "SECTION_SLOTS": "Prenotazioni e turni tavolo",
    "DURATION_MIN": "Durata predefinita ospiti (minuti)",
    "MIN_DURATION": "Permanenza minima ospiti (minuti)",
    "MAX_DURATION": "Permanenza massima ospiti (minuti)",
    "PREP_MIN": "Tempo preparazione prima dell’arrivo (minuti)",
    "COOLDOWN_MIN": "Tempo pulizia dopo l’uscita (minuti)",
    "GRID_STEP": "Passo griglia orari di inizio (minuti)",
    "BUFFER_TOTAL": "Finestra tipica bloccata per tavolo: {{minutes}} minuti (prep + durata predefinita + cooldown).",
    "MIN_MAX_DURATION": "La permanenza minima non può essere maggiore della massima.",
    "SECTION_NO_AVAIL": "Chat: messaggio senza disponibilità",
    "HINT_NO_AVAIL": "Mostrato quando il chatbot non trova tavoli (dopo ±30 minuti). Variabili: {date}, {time}, {partySize}, {restaurant}, {phone} (telefono dell’attività nel profilo tenant). Il chatbot deve inviare il testo così com’è.",
    "NO_AVAIL_TEMPLATE": "Modello messaggio",
    "NO_AVAIL_PLACEHOLDER": "Ci dispiace, non abbiamo tavoli il {date} verso le {time} per {partySize} persone.",
    "SECTION_PARTY_SIZE_EXCEEDED": "Chat: gruppo troppo numeroso",
    "HINT_PARTY_SIZE_EXCEEDED": "Mostrato quando il numero di ospiti supera la capienza massima di tavoli e combinazioni in planimetria. Variabili: {partySize}, {maxPartySize}, {date}, {restaurant}, {phone}. Il chatbot deve inviare il testo così com’è.",
    "PARTY_SIZE_EXCEEDED_TEMPLATE": "Modello messaggio",
    "PARTY_SIZE_EXCEEDED_PLACEHOLDER": "Ci dispiace, non possiamo ospitare {partySize} persone: la nostra configurazione massima è di {maxPartySize} posti. Chiamaci al {phone} o prova con un gruppo più piccolo.",
    "PREVIEW_LABEL": "Anteprima (valori di esempio)",
    "SLOT_STEP": "Intervallo slot (minuti)",
    "HINT_SLOTS": "Gli orari di inizio usano il passo griglia (es. ogni 15 minuti). Prep e cooldown estendono il blocco del tavolo prima e dopo la fascia ospiti. Min/max consentono durate diverse quando il calendario lo permette (anche slot parziali in chat).",
    "DAY_OPEN_LABEL": "Aperto",
    "DAY_CLOSED_LABEL": "Chiuso",
    "DAY_TOGGLE_ARIA": "Apri o chiudi {{label}}",
    "DAY_OFF_HELP": "In questo giorno non si possono prenotare tavoli. Attiva l’interruttore per impostare gli orari.",
    "CALLOUT_SLOTS": "Esempio: permanenza predefinita 60 min, griglia 15 min → possibili partenze ogni 15 minuti se il tavolo è libero per tutta la durata più i buffer. In chat gli slot parziali usano un’ora di fine anticipata se c’è solo un intervallo limitato prima della prossima prenotazione.",
    "WEEKDAYS": {
      "D0": "Domenica",
      "D1": "Lunedì",
      "D2": "Martedì",
      "D3": "Mercoledì",
      "D4": "Giovedì",
      "D5": "Venerdì",
      "D6": "Sabato"
    }
  },

  "LAYOUT": {
    "DEFAULT_SECTION_LABEL": "Personal Care",
    "CHANGE_TENANT": "Cambia tenant",
    "SELECT_TENANT": "Seleziona tenant..."
  },

  "NOTIFICATIONS_PAGE": {
    "SUBTITLE": "Elementi azionabili e non letti per il tuo tenant.",
    "UNREAD": "Non letto",
    "READ": "Letto",
    "ACTION_NEEDED": "Intervento necessario",
    "EMPTY_UNREAD": "Nessuna notifica non letta.",
    "EMPTY_READ": "Nessuna notifica letta.",
    "EMPTY_ACTION_NEEDED": "Nessun intervento necessario al momento.",
    "EMPTY_ALL": "Nessuna notifica.",
    "SYSTEM": "Sistema",
    "SYSTEM_COMING_SOON": "Le notifiche di sistema compariranno qui.",
    "FILTER_ALL": "Tutte",
    "FILTER_UNREAD": "Non lette",
    "FILTER_READ": "Lette",
    "FILTER_APPOINTMENTS": "Appuntamenti",
    "FILTER_APPOINTMENTS_UNREAD": "Appuntamenti - Non letti",
    "FILTER_CHAT": "Chat",
    "FILTER_CHAT_UNREAD": "Chat - Non lette",
    "FILTER_SYSTEM": "Sistema",
    "FILTER_NEW_MEMBER": "Nuovo membro",
    "TYPE_CHAT_INTERVENTION_NEEDED": "Intervento chat",
    "TYPE_SYSTEM_ERROR": "Errore sistema",
    "TYPE_APPOINTMENT_NEW": "Nuovo appuntamento",
    "TYPE_APPOINTMENT_CANCELLED": "Appuntamento annullato",
    "TYPE_APPOINTMENT_MODIFIED": "Appuntamento modificato",
    "TYPE_TENANT_NEW_MEMBER": "Nuovo membro del team",
    "COLUMN_TYPE": "Tipo",
    "COLUMN_TITLE": "Titolo",
    "COLUMN_STATUS": "Stato",
    "COLUMN_DATE": "Data",
    "COLUMN_DETAILS": "Dettagli",
    "DETAILS_CREATED_AT": "Creato",
    "DETAILS_APPOINTMENT_ID": "Appuntamento",
    "DETAILS_ERROR_CODE": "Codice errore",
    "DETAILS_OPEN_CHAT": "Apri chat",
    "ACTION_GO_TO_AGENDA": "Vai all'agenda",
    "ACTION_GO_TO_TEAM": "Vai al team"
  },

  "SIDEBAR": {
    "HELP_TITLE": "Serve aiuto?",
    "HELP_TEXT": "Contatta il supporto o consulta le guide.",
    "COLLAPSE": "Comprimi barra laterale",
    "EXPAND": "Espandi barra laterale",
    "MAIN_NAV": "Navigazione principale"
  },

  "SETTINGS": {
    "TABS": {
      "PROFILE": "Profilo",
      "BUSINESS": "Azienda",
      "NOTIFICATIONS": "Notifiche",
      "APPEARANCE": "Aspetto",
      "SECURITY": "Sicurezza",
      "BILLING": "Fatturazione",
      "INTEGRATIONS": "Integrazioni",
      "CHATBOT": "Chatbot"
    },
    "PROFILE_TITLE": "Impostazioni profilo",
    "CHANGE_PHOTO": "Cambia foto",
    "PHOTO_HINT": "JPG, PNG o GIF. Max 2MB.",
    "FIRST_NAME": "Nome",
    "LAST_NAME": "Cognome",
    "EMAIL": "Email",
    "PHONE": "Telefono",
    "PROFILE_SAVED": "Profilo salvato con successo.",
    "SAVE_CHANGES": "Salva modifiche",
    "SAVING": "Salvataggio...",
    "FOOD_SETTINGS_LINK": "Apri impostazioni ristorante e prenotazioni",
    "FOOD_SETTINGS_LINK_HINT": "Orari, giorni lavorativi e durata prenotazione sono in una pagina dedicata.",
    "BUSINESS_TITLE": "Dettagli azienda",
    "UPLOAD_LOGO": "Carica logo",
    "LOGO_HINT": "Dimensione consigliata 400x400px.",
    "COMPANY_NAME": "Nome azienda",
    "INDUSTRY": "Settore",
    "BUSINESS_ADDRESS": "Indirizzo",
    "TAX_INFO_TITLE": "Informazioni fiscali",
    "VAT_ID": "P. IVA",
    "CURRENCY": "Valuta",
    "BUSINESS_SAVED": "Informazioni azienda salvate con successo.",
    "SAVE_BUSINESS": "Salva informazioni azienda",
    "COMM_PREFS_TITLE": "Preferenze notifiche",
    "COMM_PREFS_SUBTITLE": "I canali di invio valgono per tutto il workspace. Solo gli admin possono modificarli; gli operator possono collegare il proprio Telegram qui sotto.",
    "NOTIF_ROW_APPOINTMENT_NEW": "Nuovo appuntamento ricevuto",
    "NOTIF_ROW_APPOINTMENT_NEW_DESC": "Quando un cliente prenota tramite chatbot o moduli.",
    "NOTIF_ROW_APPOINTMENT_CANCELLED": "Appuntamento cancellato o eliminato",
    "NOTIF_ROW_APPOINTMENT_CANCELLED_DESC": "Quando un appuntamento viene annullato o rimosso.",
    "NOTIF_ROW_APPOINTMENT_MODIFIED": "Appuntamento modificato",
    "NOTIF_ROW_APPOINTMENT_MODIFIED_DESC": "Quando cambiano data, ora, servizio o altri dettagli.",
    "NOTIF_ROW_TENANT_MEMBER": "Nuovo collaboratore o admin",
    "NOTIF_ROW_TENANT_MEMBER_DESC": "Quando qualcuno entra nel team del tenant.",
    "NOTIF_ROW_HUMAN_ASSISTANT": "Assistenza umana necessaria",
    "NOTIF_ROW_HUMAN_ASSISTANT_DESC": "Quando una conversazione richiede un operatore o c’è un problema di configurazione chatbot.",
    "NOTIF_MATRIX_EVENT": "Notifica",
    "NOTIF_CHANNEL_IN_APP": "Elenco in-app",
    "NOTIF_CHANNEL_EMAIL": "Email",
    "NOTIF_CHANNEL_TELEGRAM": "Telegram",
    "NOTIF_SAVE": "Salva preferenze notifiche",
    "NOTIF_TELEGRAM_INFO_TITLE": "Notifiche Telegram",
    "NOTIF_TELEGRAM_INFO_DESC": "Dopo aver collegato il bot notifiche (Integrazioni), chiunque apra il bot e prema Avvia riceverà automaticamente gli avvisi per gli eventi con Telegram attivo sopra. Per disiscriversi, inviare /stop al bot.",
    "NOTIF_TELEGRAM_OPEN_BOT": "Apri bot su Telegram",
    "NOTIF_TELEGRAM_BOT_NOT_CONNECTED": "Collega prima il bot notifiche (tab Integrazioni).",
    "NOTIF_TELEGRAM_SUBSCRIBERS": "Iscritti attivi",
    "NOTIFICATION_PREFS": {
      "LOADING": "Caricamento preferenze…",
      "NO_TENANT": "Seleziona un tenant per gestire le notifiche.",
      "ERROR_LOAD": "Impossibile caricare le preferenze notifiche.",
      "ERROR_SAVE": "Impossibile salvare le preferenze notifiche."
    },
    "NOTIFICATIONS_TELEGRAM_BOT_TITLE": "Bot notifiche (tenant)",
    "NOTIFICATIONS_TELEGRAM_BOT_DESC": "Crea un bot Telegram separato con BotFather solo per le notifiche allo staff. Chiunque apra il bot e prema Avvia riceverà gli avvisi; questo bot non gestisce la chat clienti.",
    "NOTIFICATIONS_TELEGRAM": {
      "CONNECT": "Collega bot notifiche",
      "DISCONNECT": "Scollega bot",
      "DISCONNECT_CONFIRM_TITLE": "Scollegare il bot notifiche?",
      "DISCONNECT_CONFIRM_MESSAGE": "Lo staff smetterà di ricevere notifiche Telegram finché non colleghi un nuovo bot.",
      "CONNECT_ERROR": "Impossibile collegare il bot notifiche.",
      "DISCONNECT_ERROR": "Impossibile scollegare il bot notifiche.",
      "LINK_ERROR": "Impossibile avviare il collegamento Telegram. Verifica che il bot notifiche sia configurato e riprova.",
      "UNLINK_ERROR": "Impossibile scollegare Telegram."
    },
    "APPEARANCE_TITLE": "Aspetto e stile",
    "AI_AUTO_DISABLE_TITLE": "Disattivazione automatica AI",
    "AI_AUTO_DISABLE_LABEL": "Disattiva AI dopo N risposte mancate",
    "AI_AUTO_DISABLE_DESC": "Imposta 0 per disabilitare questa funzione. Dopo N fallimenti consecutivi, la Modalità AI verrà disattivata per quella chat.",
    "AI_AUTO_DISABLE_SAVED": "Policy di disattivazione automatica AI salvata.",
    "THEME_PREFERENCES": "Preferenze tema",
    "THEME_LIGHT": "Chiaro",
    "THEME_DARK": "Scuro",
    "SECURITY_TITLE": "Sicurezza e accesso",
    "TWO_FA_TITLE": "Autenticazione a due fattori",
    "TWO_FA_DESC": "Aggiungi un ulteriore livello di sicurezza richiedendo più della password per accedere.",
    "SETUP_2FA": "Configura 2FA",
    "CHANGE_PASSWORD": "Cambia password",
    "CURRENT_PASSWORD": "Password attuale",
    "NEW_PASSWORD": "Nuova password",
    "PASSWORD_UPDATED": "Password aggiornata con successo.",
    "UPDATING": "Aggiornamento...",
    "UPDATE_PASSWORD": "Aggiorna password",
    "ACTIVE_SESSIONS": "Sessioni attive",
    "ACTIVE_NOW": "Attivo ora",
    "LAST_ACTIVE_AGO": "Ultimo accesso 2h fa",
    "BILLING_UNAVAILABLE": "La fatturazione non è ancora disponibile.",
    "INTEGRATIONS_TITLE": "Integrazioni",
    "CHATBOT_TITLE": "Messaggi del chatbot",
    "CHATBOT_IDENTIFICATION_TITLE": "Onboarding",
    "CHATBOT_KNOWLEDGE_BASE_TITLE": "Knowledge Base",
    "CHATBOT_ERRORS_TITLE": "Messaggi di errore",
    "CHATBOT_SAVED": "Messaggi del chatbot salvati con successo.",
    "APPOINTMENT_CALENDARS": "Calendari appuntamenti",
    "GOOGLE_CALENDAR": "Google Calendar",
    "GOOGLE_CALENDAR_DESC": "Sincronizza gli appuntamenti automaticamente",
    "MANAGE_CONNECTION": "Gestisci connessione",
    "APPLE_CALENDAR": "Apple Calendar",
    "APPLE_CALENDAR_DESC": "Sincronizzazione bidirezionale con iCloud",
    "CONNECT": "Connetti",
    "CONVERSATIONS_SECTION": "Conversazioni",
    "WHATSAPP_BUSINESS": "WhatsApp Business",
    "CONNECTED": "Connesso:",
    "WHATSAPP_CONNECT_DESC": "Richiedi un numero WhatsApp. Un super admin lo assegnerà dopo l'approvazione.",
    "WHATSAPP_PENDING": "Richiesta in attesa di approvazione.",
    "WHATSAPP_REJECTED": "L'ultima richiesta è stata rifiutata. Puoi inviarne una nuova.",
    "REQUEST_WHATSAPP": "Richiedi connessione",
    "DISCONNECT": "Disconnetti",
    "CONNECT_NUMBER": "Richiedi connessione",
    "TELEGRAM_BOT": "Bot Telegram",
    "CHATBOT": {
      "WELCOME_MESSAGE": "Ciao! Sono il bot. Per poter continuare ho bisogno di alcune informazioni. Come ti chiami?",
      "WELCOME_BACK_MESSAGE": "Bentornato! Come posso aiutarti?",
      "CONFIRMATION_MESSAGE": "Grazie! Sei stato registrato. Come posso aiutarti?",
      "FIRST_NAME_QUESTION": "Come ti chiami? (nome)",
      "LAST_NAME_QUESTION": "Qual è il tuo cognome?",
      "PHONE_QUESTION": "Qual è il tuo numero di telefono? (es. 333 1234567)",
      "NO_INFORMATION_AVAILABLE": "Mi dispiace, non ho informazioni su questo argomento nella mia knowledge base.",
      "ERROR_OCCURRED": "Si è verificato un errore. Riprova più tardi.",
      "ERROR_LOAD": "Impossibile caricare i messaggi del chatbot.",
      "ERROR_SAVE": "Impossibile salvare i messaggi del chatbot.",
      "SYSTEM_MESSAGES": {
        "TITLE": "Messaggi di sistema",
        "SUBTITLE": "Personalizza i messaggi automatici inviati dall’AI nelle varie situazioni. Se lasci vuoto un campo verrà usato il testo di default.",
        "PLACEHOLDER": "Inserisci un testo personalizzato (opzionale)",
        "LABELS": {
          "WELCOME": "Messaggio di benvenuto",
          "KB_NOT_FOUND": "Info non trovata nella Knowledge Base",
          "SYSTEM_ERROR": "Errore di sistema",
          "OUT_OF_HOURS": "Fuori orario",
          "HANDOFF_TO_HUMAN": "Handoff all'operatore umano",
          "NO_OPERATOR_AVAILABLE": "Nessun operatore disponibile",
          "BOOKING_CONFIRMED": "Prenotazione confermata",
          "BOOKING_RESCHEDULED": "Prenotazione modificata",
          "BOOKING_CANCELLED": "Prenotazione annullata",
          "NO_AVAILABILITY_FOUND": "Nessuna disponibilità trovata",
          "FORM_SENT": "Form inviato all'utente",
          "FORM_COMPLETED_THANKS": "Form completato — ringraziamento",
          "INPUT_NOT_UNDERSTOOD": "Input non compreso",
          "UNSUPPORTED_MEDIA": "Messaggio non supportato (media/file)",
          "PRIVACY_CONSENT_REQUEST": "Richiesta consenso privacy (GDPR)",
          "PRIVACY_CONSENT_DENIED": "Consenso privacy negato",
          "CONVERSATION_CLOSED": "Conversazione chiusa",
          "REACTIVATION": "Messaggio di riattivazione"
        }
      },
      "FOOD_DINING": {
        "TITLE": "Prenotazione tavolo via chat",
        "SUBTITLE": "Solo per business food: indica il Servizio usato quando l’AI crea prenotazioni tavolo (crea ad es. “Prenotazione tavolo” in Servizi). Gli orari usano lo stesso giorno UTC della planimetria.",
        "SERVICE_ID": "ID servizio prenotazione tavolo",
        "SERVICE_HINT": "ID MongoDB a 24 caratteri dalla lista Servizi.",
        "SERVICE_PLACEHOLDER": "es. 674a1b2c3d4e5f6789012345",
        "DURATION": "Durata prenotazione (minuti)",
        "DAY_START": "Primo orario prenotabile (HH:mm)",
        "DAY_END": "Fine finestra per ultimo slot (HH:mm)",
        "SLOT_STEP": "Minuti tra orari di inizio proposti",
        "SAVE": "Salva impostazioni prenotazione tavolo",
        "ERROR_SAVE": "Impossibile salvare le impostazioni prenotazione tavolo."
      }
    },
    "TELEGRAM": {
      "SETUP_TITLE": "Configura Bot Telegram",
      "SETUP_SUBTITLE": "Segui i passaggi per creare e configurare il tuo bot Telegram",
      "CLOSE_ARIA": "Chiudi",
      "QR_GENERATING": "Generazione QR code...",
      "QR_FALLBACK": "Se il QR code non viene visualizzato, usa il link qui sotto per aprire BotFather",
      "QR_HINT": "Scansiona il QR code con Telegram per aprire BotFather direttamente",
      "OPEN_BOTFATHER": "Oppure apri BotFather manualmente",
      "STEPS_TITLE": "Passaggi da seguire:",
      "STEP_1_TITLE": "Apri Telegram",
      "STEP_1_DESC": "Apri l'app Telegram sul tuo telefono o desktop",
      "STEP_2_TITLE": "Cerca BotFather",
      "STEP_2_DESC": "Cerca @BotFather nella barra di ricerca di Telegram",
      "STEP_3_TITLE": "Crea un nuovo bot",
      "STEP_3_DESC": "Invia il comando /newbot a BotFather",
      "STEP_4_TITLE": "Configura il bot",
      "STEP_4_DESC": "Scegli un nome e un username per il tuo bot (deve terminare con \"bot\")",
      "STEP_5_TITLE": "Copia il token",
      "STEP_5_DESC": "BotFather ti fornirà un Bot Token. Copialo e incollalo qui sotto",
      "BOT_TOKEN_LABEL": "Bot Token",
      "BOT_TOKEN_PLACEHOLDER": "123456789:ABCdefGHIjklMNOpqrsTUVwxyz",
      "BOT_TOKEN_HINT": "Incolla qui il token fornito da BotFather dopo aver creato il bot",
      "TOKEN_REQUIRED": "Il bot token è obbligatorio",
      "TOKEN_INVALID": "Formato token non valido. Il token deve avere il formato: numero:caratteri",
      "CANCEL": "Annulla",
      "CONNECT_BOT": "Connetti Bot",
      "CONNECTING": "Connessione...",
      "QR_MODAL_TITLE": "QR Code del bot",
      "QR_MODAL_HINT": "Inquadra il QR code con la fotocamera per aprire il bot su Telegram",
      "DOWNLOAD_QR": "Scarica immagine QR",
      "COPY_LINK": "Copia link",
      "LINK_COPIED": "Link copiato",
      "SHARE_BOT_LINK": "Condividi il link del tuo bot",
      "OPEN_BOT_ON_TELEGRAM": "Apri bot su Telegram",
      "QR_OR_SHARE": "QR code / Condividi",
      "BOT_CONNECTED_ACTIVE": "Bot connesso e attivo",
      "INTEGRATE_BOT": "Integra il tuo bot per notifiche e chat.",
      "CONFIGURE_BOT": "Configura Bot",
      "DISCONNECT_CONFIRM_TITLE": "Scollega Telegram",
      "DISCONNECT_CONFIRM_MESSAGE": "Sei sicuro di voler scollegare Telegram? I messaggi non verranno più ricevuti.",
      "CONNECT_ERROR": "Errore: verifica che il bot token sia valido. Ottienilo da @BotFather su Telegram.",
      "DISCONNECT_ERROR": "Errore durante la disconnessione di Telegram."
    },
    "WHATSAPP_SHARE": {
      "CLOSE_ARIA": "Chiudi",
      "QR_GENERATING": "Generazione codice QR…",
      "QR_MODAL_TITLE": "Numero WhatsApp",
      "QR_MODAL_HINT": "Inquadra il codice QR con il telefono per aprire la chat su WhatsApp",
      "QR_IMAGE_ALT": "Codice QR per aprire WhatsApp",
      "DOWNLOAD_QR": "Scarica immagine QR",
      "COPY_LINK": "Copia link",
      "LINK_COPIED": "Link copiato",
      "SHARE_NUMBER": "Condividi il numero WhatsApp Business",
      "OPEN_ON_WHATSAPP": "Apri su WhatsApp",
      "QR_OR_SHARE": "QR code / Condividi"
    },
    "WIDGET": {
      "TITLE": "Widget Chat Sito Web",
      "DESCRIPTION_GENERATED": "Widget code generato. Copia lo snippet per integrare il widget sul tuo sito.",
      "DESCRIPTION_NOT_GENERATED": "Genera un widget code per integrare il chatbot sul tuo sito web.",
      "GENERATE_BUTTON": "Genera Widget Code",
      "REGENERATE_BUTTON": "Rigenera",
      "ENABLE_BUTTON": "Attiva",
      "DISABLE_BUTTON": "Disattiva",
      "COPY_SNIPPET": "Copia Snippet",
      "TEST_WIDGET": "Prova Widget",
      "LOADING": "Caricamento...",
      "ACTIVE": "Attivo",
      "INACTIVE": "Inattivo",
      "ERROR_NOT_GENERATED": "Widget code non generato. Genera un widget code dalle Settings.",
      "ERROR_LOADING": "Errore durante il caricamento dello stato widget",
      "ERROR_GENERATING": "Errore durante la generazione del widget code",
      "ERROR_TOGGLE": "Errore durante l'aggiornamento dello stato widget",
      "REGENERATE_CONFIRM_TITLE": "Rigenera Widget Code",
      "REGENERATE_CONFIRM_MESSAGE": "Sei sicuro di voler rigenerare il widget code? Il vecchio codice smetterà di funzionare e dovrai aggiornare lo snippet sul tuo sito.",
      "SNIPPET_COPIED": "Snippet copiato negli appunti!"
    },
    "PROFILE": {
      "ERROR_SAVE": "Impossibile salvare il profilo."
    },
    "BUSINESS": {
      "ERROR_SAVE": "Impossibile salvare i dettagli azienda."
    },
    "SECURITY": {
      "PASSWORD_ERROR": "Impossibile aggiornare la password."
    },
    "AI_AUTO_DISABLE": {
      "ERROR_LOAD": "Impossibile caricare le impostazioni di disattivazione automatica AI.",
      "ERROR_SAVE": "Impossibile salvare le impostazioni di disattivazione automatica AI."
    },
    "INTEGRATIONS": {
      "POPUP_BLOCKED": "Popup bloccato. Consenti i popup per questo sito per continuare."
    },
    "WHATSAPP": {
      "DISCONNECT_ERROR": "Impossibile disconnettere WhatsApp.",
      "REQUEST_ERROR": "Impossibile inviare la richiesta WhatsApp."
    }
  },

  "DASHBOARD": {
    "GOOD_MORNING": "Buongiorno",
    "GOOD_AFTERNOON": "Buon pomeriggio",
    "GOOD_EVENING": "Buonasera",
    "WELCOME_SUBTITLE": "Ecco cosa succede nella tua attività oggi.",
    "QUICK_ACTIONS": "Azioni rapide",
    "KEY_METRICS": "Metriche chiave",
    "ACTIVITY": "Attività",
    "NEW_BOOKING": "Nuova prenotazione",
    "REPORTS": "Report",
    "TODAYS_AGENDA": "Agenda di oggi",
    "SOON": "Prossimamente",
    "LIVE_INBOX_TITLE": "Conversazioni live",
    "VIEW_ALL": "Vedi tutti ↗",
    "LIVE_INBOX_DESC": "Ultimi messaggi dei clienti in attesa di risposta",
    "OPEN_CHAT": "Apri chat",
    "AI_SUMMARY": "Riepilogo AI:",
    "INSIGHTS_TITLE": "Insight giornalieri",
    "MOST_ASKED_TODAY": "Più richiesto oggi:",
    "SUGGESTION": "Suggerimento:",
    "DEFAULT_QUESTION": "Quanto dura il recupero?",
    "DEFAULT_SUGGESTION": "3 clienti hanno chiesto informazioni sul post-trattamento. Valuta di aggiungere una \"Risposta rapida\" per i peeling.",
    "DEFAULT_TREND": "Conversioni prenotazioni +5% rispetto alla settimana scorsa"
  },

  "TENANT_MODAL": {
    "TITLE_CREATE": "Crea Nuovo Tenant",
    "TITLE_EDIT": "Modifica Tenant",
    "SUBTITLE": "Configura impostazioni tenant e preferenze AI.",
    "SECTION_BUSINESS_DETAILS": "Dettagli Azienda",
    "SECTION_AI_SETTINGS": "Impostazioni AI",
    "SECTION_AI_CONFIGURATION": "Configurazione AI",
    "LABEL_AI_NAME": "NOME AI",
    "PLACEHOLDER_AI_NAME": "es. Bot Supporto",
    "LABEL_AI_PERSONALITY": "PERSONALITÀ E TONO AI",
    "PLACEHOLDER_AI_PERSONALITY": "Sei un assistente clienti utile e cortese. Parli con un tono formale...",
    "LABEL_AI_LIMITS": "LIMITI E REGOLE AI",
    "PLACEHOLDER_AI_LIMITS": "Non rispondere a domande sulla politica. Non fornire consigli medici. Lunghezza massima risposta: 50 parole...",
    "DESCRIPTION_AI_LIMITS": "Definisci confini rigorosi e regole operative per il modello AI.",
    "LABEL_BUSINESS_NAME": "NOME AZIENDA",
    "LABEL_EMAIL": "EMAIL",
    "PLACEHOLDER_EMAIL": "nome@azienda.com",
    "LABEL_PHONE": "TELEFONO",
    "LABEL_VERTICAL": "SETTORE",
    "LABEL_TIER": "PIANO",
    "LABEL_LANGUAGE": "LINGUA",
    "LABEL_AI_CONFIGURATIONS": "CONFIGURAZIONI AI",
    "LABEL_AI_TYPE": "TIPO AI",
    "LABEL_MODEL": "MODELLO",
    "LABEL_API_KEY": "CHIAVE API",
    "LABEL_API_KEY_UPDATE": "CHIAVE API (lascia vuoto per mantenere quella attuale)",
    "PLACEHOLDER_API_KEY": "Inserisci chiave API",
    "BUTTON_ADD_AI_CONFIG": "Aggiungi Configurazione AI",
    "BUTTON_CANCEL": "Annulla",
    "BUTTON_CREATE": "Crea Tenant",
    "BUTTON_UPDATE": "Aggiorna Tenant",
    "BUTTON_CREATING": "Creazione...",
    "BUTTON_UPDATING": "Aggiornamento...",
    "ERROR_CREATING": "Errore nella creazione del tenant",
    "ERROR_UPDATING": "Errore nell'aggiornamento del tenant"
  },

  "CONTACTS": {
    "TITLE": "Contatti",
    "MANAGE_FIELDS": "Gestisci campi",
    "UPLOAD_CONTACT_LIST": "Carica lista contatti",
    "ADD_CONTACT": "Aggiungi un contatto",
    "SEARCH_PLACEHOLDER": "Cerca contatti per nome, email o telefono...",
    "FILTER_BY": "Filtra per:",
    "ALL_CONTACTS": "Tutti i contatti",
    "ACTIVE": "Attivi",
    "INACTIVE": "Inattivi",
    "NO_CONTACTS_FOUND": "Nessun contatto trovato",
    "SHOWING": "Visualizzazione",
    "OF": "di",
    "CONTACTS": "contatti",
    "DELETE_CONFIRM_TITLE": "Conferma eliminazione",
    "DELETE_CONFIRM": "Sei sicuro di voler eliminare questo contatto?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Errore nel caricamento dei contatti",
    "ERROR_DELETING": "Errore nell'eliminazione del contatto",
    "DELETE_SUCCESS": "Contatto eliminato con successo.",
    "PLATFORMS": {
      "WHATSAPP": "WhatsApp",
      "TELEGRAM": "Telegram",
      "EMAIL": "Email",
      "MANUAL": "Manuale",
      "WEBCHAT": "Chat web"
    },
    "STATUS": {
      "ACTIVE": "Attivo",
      "INACTIVE": "Inattivo"
    },
    "LAST_ACTIVE": {
      "LABEL": "Ultima Attività",
      "JUST_NOW": "Proprio ora",
      "MINUTES_AGO": "{{minutes}}m fa",
      "HOURS_AGO": "{{hours}}h fa",
      "DAYS_AGO": "{{days}}g fa",
      "WEEKS_AGO": "{{weeks}}s fa"
    },
    "MODAL": {
      "ADD_TITLE": "Aggiungi Nuovo Contatto",
      "EDIT_TITLE": "Modifica Contatto",
      "ADD_SUBTITLE": "Crea un nuovo profilo nel tuo workspace.",
      "EDIT_SUBTITLE": "Aggiorna le informazioni del contatto esistente.",
      "BASIC_INFO": "Informazioni Base",
      "FULL_NAME": "Nome",
      "FULL_NAME_PLACEHOLDER": "es. Elena",
      "LAST_NAME": "Cognome",
      "LAST_NAME_PLACEHOLDER": "es. Rossi",
      "EMAIL_ADDRESS": "Indirizzo Email",
      "EMAIL_PLACEHOLDER": "nome@esempio.com",
      "PHONE_NUMBER": "Numero di Telefono",
      "PHONE_PLACEHOLDER": "+39 000 00000",
      "PREFERENCES": "Preferenze",
      "FAVOURITE_CONTACT_METHOD": "Metodo di contatto preferito",
      "STATUS": "Stato",
      "ACTIVE_STATUS_LABEL": "Stato attivo",
      "ACTIVE_STATUS_DESCRIPTION": "Il contatto è raggiungibile?",
      "CUSTOM_ATTRIBUTES": "Attributi Personalizzati",
      "TAGS_LABELS": "Tag e Etichette",
      "TAGS_ASSIGNED": "assegnati",
      "TAGS_PLACEHOLDER": "Seleziona tag...",
      "MORE_TAGS": "altri +",
      "CANCEL": "Annulla",
      "CREATE_CONTACT": "Crea Contatto",
      "UPDATE_CONTACT": "Aggiorna Contatto",
      "ERROR_CREATING": "Errore nella creazione del contatto",
      "ERROR_UPDATING": "Errore nell'aggiornamento del contatto",
      "YES": "Sì",
      "NO": "No",
      "ENTER_FIELD_PLACEHOLDER": "Inserisci {{label}}..."
    },
    "DETAIL": {
      "BACK": "Indietro",
      "PAGE_TITLE": "Dettaglio contatto",
      "SUBTITLE": "Visualizza e modifica le informazioni del contatto",
      "NOT_FOUND": "Contatto non trovato.",
      "DELETE": "Elimina",
      "SAVE_SUCCESS": "Contatto aggiornato con successo.",
      "SUMMARY": {
        "TITLE": "Riassunto AI contatto",
        "EMPTY": "Nessun riassunto disponibile.",
        "GENERATE": "Genera riassunto",
        "REFRESH": "Aggiorna riassunto",
        "IN_PROGRESS": "Aggiornamento in corso",
        "REFRESH_STARTED": "Generazione riassunto avviata in background.",
        "REFRESH_ERROR": "Impossibile avviare la generazione del riassunto.",
        "STATUS_NOT_STARTED": "Non avviato",
        "STATUS_IN_PROGRESS": "In progress",
        "STATUS_COMPLETE": "Complete",
        "STATUS_FAILED": "Failed",
        "STATUS_NEED_UPDATE": "Need update",
        "META_FIRST_COMPLETE": "Primo riassunto completato",
        "META_LAST_COMPLETED": "Ultimo riassunto completato",
        "META_LAST_REQUESTED": "Ultimo aggiornamento richiesto",
        "META_SOURCE_UPDATED": "Ultima modifica dati contatto",
        "META_VERSION": "Versione riassunto",
        "META_NOT_AVAILABLE": "—",
        "NEED_UPDATE_HINT": "I dati del contatto sono cambiati dopo l'ultimo riassunto. Aggiorna il riassunto così l'assistente AI usa informazioni aggiornate."
      },
      "SUMMARY_CHAT": {
        "TITLE": "Assistente AI contatto",
        "SUBTITLE": "Risposte solo dalla KB del contatto (riassunto + appuntamenti), senza rigenerare il summary",
        "READY": "Pronta",
        "LOCKED": "Bloccata",
        "LOCK_HINT": "Genera almeno una volta il riassunto per abilitare la chat. Durante una nuova generazione la chat è disabilitata.",
        "HINT": "Fai una domanda: l'AI usa solo riassunto salvato, appuntamenti e testi allegati (nessuna rigenerazione del summary).",
        "PLACEHOLDER": "Scrivi una domanda…",
        "INPUT_LOCKED": "La chat è disabilitata finché il riassunto non è Complete.",
        "AI_EMPTY": "L'AI ha restituito una risposta vuota. Riprova o aggiorna il riassunto.",
        "ERROR": "Non sono riuscito a rispondere ora. Riprova.",
        "RESPONDING": "Sta rispondendo…"
      },
      "CONVERSATIONS": "Conversazioni",
      "NO_CONVERSATIONS": "Nessuna conversazione.",
      "NO_MESSAGES": "Nessun messaggio",
      "APPOINTMENTS": "Prenotazioni",
      "NO_APPOINTMENTS": "Nessuna prenotazione.",
      "FORMS": {
        "BUTTON": "Form",
        "EMPTY": "Nessun form per questo appuntamento.",
        "TYPE_REQUIRED": "Obbligatorio",
        "TYPE_OPTIONAL": "Facoltativo",
        "TYPE_UNKNOWN": "Tipo non disponibile",
        "STATUS_SUBMITTED": "Compilato",
        "STATUS_PENDING": "Non compilato",
        "STATUS_EMPTY": "Non disponibile",
        "PENDING_INFO": "Il cliente non ha ancora compilato questo form."
      }
    },
    "APPOINTMENT_DETAIL": {
      "PAGE_TITLE": "Appuntamento",
      "SUBTITLE": "Note e allegati per questo appuntamento",
      "BACK_TO_CONTACT": "Torna al contatto",
      "NOT_FOUND": "Appuntamento non trovato.",
      "LOAD_ERROR": "Impossibile caricare l'appuntamento.",
      "BASIC": "Dettagli",
      "SERVICE": "Servizio",
      "DATE": "Data",
      "TIME": "Orario",
      "STATUS": "Stato",
      "NOTES": "Note",
      "NOTES_PLACEHOLDER": "Aggiungi note per questo appuntamento...",
      "SAVE_NOTES": "Salva note",
      "NOTES_SAVED": "Note salvate.",
      "NOTES_SAVE_ERROR": "Impossibile salvare le note.",
      "ATTACHMENTS": "Allegati",
      "ATTACHMENTS_HINT": "Trascina i file qui o clicca per selezionare. Consentiti: PDF, documenti Office, immagini, TXT.",
      "SELECT_FILES": "Scegli file",
      "UPLOADING": "Caricamento...",
      "UPLOAD_SUCCESS": "File caricati.",
      "UPLOAD_ERROR": "Caricamento non riuscito.",
      "NO_ATTACHMENTS": "Nessun allegato.",
      "COL_NAME": "File",
      "COL_TYPE": "Tipo",
      "COL_SIZE": "Dimensione",
      "COL_UPLOADED": "Caricato",
      "COL_USER": "Utente",
      "COL_ACTIONS": "Azioni",
      "PREVIEW": "Anteprima",
      "DOWNLOAD": "Scarica",
      "DELETE": "Rimuovi",
      "DELETE_CONFIRM_TITLE": "Rimuovi allegato",
      "DELETE_CONFIRM": "Rimuovere <strong>{{name}}</strong> da questo appuntamento?",
      "DELETE_SUCCESS": "Allegato rimosso.",
      "DELETE_ERROR": "Impossibile rimuovere l'allegato.",
      "DOWNLOAD_ERROR": "Impossibile scaricare il file.",
      "PREVIEW_ERROR": "Impossibile aprire l'anteprima del file.",
      "EXTRACTION_PENDING": "Estrazione in corso…",
      "EXTRACTION_COMPLETED": "Testo estratto",
      "EXTRACTION_SKIPPED": "Anteprima non disponibile",
      "EXTRACTION_FAILED": "Estrazione non riuscita",
      "BYTES": "{{size}} B",
      "KB": "{{size}} KB",
      "MB": "{{size}} MB",
      "FORMS": {
        "TITLE": "Form appuntamento",
        "EMPTY": "Nessun form per questo appuntamento.",
        "TYPE_REQUIRED": "Obbligatorio",
        "TYPE_OPTIONAL": "Facoltativo",
        "TYPE_UNKNOWN": "Tipo non disponibile",
        "STATUS_SUBMITTED": "Compilato",
        "STATUS_PENDING": "Non compilato",
        "STATUS_EMPTY": "Non disponibile",
        "PENDING_INFO": "Il cliente non ha ancora compilato questo form."
      }
    },
    "FIELDS_MANAGEMENT": {
      "TITLE": "Gestisci Campi",
      "SUBTITLE": "Configura etichette e attributi personalizzati dei contatti",
      "TAGS_TAB": "Tag e Etichette",
      "ONBOARDING_TAB": "Onboarding Chatbot",
      "CUSTOM_FIELDS_TAB": "Campi Personalizzati",
      "TAG_INPUT_PLACEHOLDER": "Inserisci il nome del nuovo tag...",
      "TAG_ALREADY_EXISTS": "Il tag esiste già",
      "TAG_CREATED": "Tag creato con successo.",
      "LOADING_TAGS": "Caricamento tag...",
      "ERROR_LOADING_TAGS": "Errore nel caricamento dei tag",
      "ERROR_CREATING_TAG": "Errore nella creazione del tag",
      "ERROR_DELETING_TAG": "Errore nell'eliminazione del tag",
      "DELETE_TAG_CONFIRM_TITLE": "Conferma eliminazione",
      "DELETE_TAG_CONFIRM_MESSAGE": "Sei sicuro di voler eliminare questo tag?\n<strong>{{name}}</strong>",
      "CREATE_FIELD": "Crea Nuovo Campo Personalizzato",
      "EDIT_FIELD": "Modifica Campo",
      "FIELD_NAME": "Nome Campo",
      "FIELD_NAME_PLACEHOLDER": "es. Compleanno",
      "SLUG_ID": "Slug (ID)",
      "SLUG_PLACEHOLDER": "es. compleanno",
      "FORMAT_TYPE": "Tipo di Formato",
      "TEXT": "Testo",
      "NUM": "Numero",
      "DATE": "Data",
      "BOOL": "Booleano",
      "ADD_CUSTOM_FIELD": "Aggiungi Campo Personalizzato",
      "UPDATE_FIELD": "Aggiorna Campo",
      "LOADING_FIELDS": "Caricamento campi personalizzati...",
      "ERROR_LOADING_FIELDS": "Errore nel caricamento dei campi personalizzati",
      "ERROR_CREATING_FIELD": "Errore nella creazione del campo personalizzato",
      "ERROR_UPDATING_FIELD": "Errore nell'aggiornamento del campo personalizzato",
      "ERROR_DELETING_FIELD": "Errore nell'eliminazione del campo personalizzato",
      "DELETE_FIELD_CONFIRM_TITLE": "Conferma eliminazione",
      "DELETE_FIELD_CONFIRM_MESSAGE": "Sei sicuro di voler eliminare questo campo personalizzato?\n<strong>{{name}}</strong>",
      "QUESTION_EXAMPLE": "Domanda / Esempio",
      "QUESTION_EXAMPLE_PLACEHOLDER": "es. Qual è la tua data di nascita?",
      "ACTIVE": "Attivo",
      "REQUIRED": "Obbligatorio",
      "REQUIRED_FOR_ONBOARDING": "Richiesto per onboarding chatbot",
      "ONBOARDING_HINT": "Se attivi “Richiesto per onboarding chatbot”, questo campo verrà chiesto automaticamente dal chatbot prima di procedere. La domanda usata è quella in “Domanda / Esempio”.",
      "ONBOARDING_QUESTION": "Domanda onboarding",
      "ONBOARDING_QUESTION_EMPTY": "Nessuna domanda personalizzata",
      "ONBOARDING_TAB_SUBTITLE": "Qui gestisci i dati base richiesti all'inizio della chat: nome, cognome, telefono ed email (email opzionale).",
      "EDIT_ONBOARDING_FIELD": "Modifica campo onboarding",
      "FIELD_ENABLED": "Campo attivo nella raccolta dati",
      "SAVE_ONBOARDING_FIELD": "Salva campo onboarding",
      "CLOSE_MANAGEMENT": "Chiudi Gestione"
    },
    "FILTERS": {
      "ADVANCED_FILTERS": "Filtri Avanzati",
      "COMMUNICATION_PLATFORM": "Piattaforma di Comunicazione",
      "CLIENT_LABELS": "Etichette Cliente",
      "LAST_ACTIVE_PERIOD": "Periodo Ultima Attività",
      "ALL_TIME": "Tutto il Tempo",
      "LAST_7_DAYS": "Ultimi 7 giorni",
      "LAST_30_DAYS": "Ultimi 30 giorni",
      "RESET_ALL": "Reimposta tutto",
      "APPLY": "Applica"
    }
  },

  "SERVICES": {
    "MANAGE_CATEGORIES": "Gestisci categorie",
    "ADD_SERVICE": "Aggiungi servizio",
    "SEARCH_PLACEHOLDER": "Cerca servizi per nome o descrizione...",
    "FILTER_BY": "Filtra per:",
    "ALL": "Tutti",
    "ACTIVE": "Attivi",
    "INACTIVE": "Inattivi",
    "FILTER_BY_CATEGORY": "Filtra per categoria",
    "CLEAR": "Cancella",
    "RESET_FILTERS": "Reimposta filtri",
    "NO_SERVICES": "Nessun servizio trovato",
    "PRICE": "Prezzo",
    "DURATION": "Durata",
    "PREP": "Prep",
    "COOLDOWN": "Cooldown",
    "SHOWING": "Visualizzazione",
    "OF": "di",
    "SERVICES": "servizi",
    "DELETE_CONFIRM_TITLE": "Conferma eliminazione",
    "DELETE_CONFIRM": "Sei sicuro di voler eliminare questo servizio?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Errore nel caricamento dei servizi",
    "ERROR_DELETING": "Errore nell'eliminazione del servizio",
    "FORMS": {
      "ADD_FORM": "Aggiungi form",
      "MANAGE_FORMS": "Gestisci form",
      "MANAGE_TITLE": "Gestione form",
      "MANAGE_SUBTITLE": "Visualizza, modifica o elimina i form di prenotazione.",
      "NO_FORMS": "Non hai ancora creato nessun form.",
      "TEST_FORM": "Testa form",
      "ADD_TITLE": "Crea nuovo form",
      "EDIT_TITLE": "Modifica form",
      "ADD_SUBTITLE": "Configura struttura e domande del nuovo form.",
      "EDIT_SUBTITLE": "Aggiorna titolo, descrizione e domande del form.",
      "METADATA_TITLE": "Impostazioni form",
      "NAME": "Nome form",
      "NAME_PLACEHOLDER": "es. Questionario pre-visita",
      "DESCRIPTION": "Descrizione (opzionale)",
      "DESCRIPTION_PLACEHOLDER": "Spiega brevemente a cosa serve questo form...",
      "QUESTIONS_TITLE": "Domande del form",
      "ADD_QUESTION": "Aggiungi domanda",
      "QUESTION_TEXT": "Testo domanda",
      "QUESTION_TEXT_PLACEHOLDER": "es. Hai allergie note?",
      "QUESTION_DESCRIPTION": "Descrizione domanda (opzionale)",
      "QUESTION_DESCRIPTION_PLACEHOLDER": "Aggiungi dettagli o istruzioni per la domanda...",
      "QUESTION_TYPE": "Tipo di risposta",
      "QUESTION_REQUIRED": "Risposta obbligatoria",
      "OPTIONS_TITLE": "Opzioni di risposta",
      "ADD_OPTION": "Aggiungi opzione",
      "OPTION_LABEL": "Opzione",
      "OPTION_PLACEHOLDER": "es. Sì",
      "TYPE_TEXT": "Risposta breve",
      "TYPE_MULTILINE": "Paragrafo",
      "TYPE_SINGLE_CHOICE": "Scelta singola",
      "TYPE_MULTIPLE_CHOICE": "Scelta multipla",
      "TYPE_NUMBER": "Numero",
      "TYPE_DATE": "Data",
      "BOOKING_FORM_TITLE": "Form di prenotazione",
      "SELECT_FORM": "Seleziona un form da associare",
      "NO_FORM": "Nessun form",
      "REQUIRED_FOR_BOOKING": "Form obbligatorio per confermare la prenotazione",
      "PRIVACY_POLICY_ENABLE": "Abilita il form Privacy & Policy",
      "PRIVACY_POLICY_TEXT_LABEL": "Testo Privacy & Policy",
      "PRIVACY_POLICY_TEXT_PLACEHOLDER": "Inserisci il testo completo della privacy policy",
      "PRIVACY_POLICY_LINK_LABEL": "Link Privacy & Policy",
      "PRIVACY_POLICY_LINK_PLACEHOLDER": "https://...",
      "SAVE": "Salva form",
      "UPDATE": "Aggiorna form",
      "ERROR_LOADING_FORMS": "Errore nel caricamento dei form",
      "DELETE_CONFIRM_TITLE": "Elimina form",
      "DELETE_CONFIRM": "Sei sicuro di voler eliminare questo form?\n<strong>{{name}}</strong>",
      "ERROR_DELETING_FORM": "Errore nell'eliminazione del form",
      "ERROR_CREATING_TEST_LINK": "Errore nella creazione del link di test per il form",
      "TEST_LINK_OPENED": "Link di test aperto in una nuova scheda.",
      "ERROR_SAVING_FORM": "Errore nel salvataggio del form",
      "ERROR_UPDATING_FORM": "Errore nell'aggiornamento del form"
    },
    "MODAL": {
      "ADD_TITLE": "Aggiungi nuovo servizio",
      "EDIT_TITLE": "Modifica servizio",
      "ADD_SUBTITLE": "Crea un nuovo servizio per il tuo catalogo.",
      "EDIT_SUBTITLE": "Aggiorna le informazioni del servizio.",
      "DETAILS": "Dettagli servizio",
      "NAME": "Nome servizio",
      "NAME_PLACEHOLDER": "es. Peeling chimico",
      "DESCRIPTION": "Descrizione",
      "DESCRIPTION_PLACEHOLDER": "Descrivi il trattamento e i suoi benefici...",
      "CATEGORIES": "Categorie",
      "CATEGORIES_PLACEHOLDER": "Seleziona categorie...",
      "MORE_CATEGORIES": "altre +",
      "PRICE_AND_DURATION": "Prezzo e durata",
      "PRICE": "Prezzo (€)",
      "PRICE_PLACEHOLDER": "es. 120",
      "DURATION": "Durata (min)",
      "DURATION_PLACEHOLDER": "es. 45",
      "PREP_TIME": "Tempo preparazione (min)",
      "PREP_PLACEHOLDER": "0",
      "COOLDOWN_TIME": "Tempo cooldown (min)",
      "COOLDOWN_PLACEHOLDER": "0",
      "BUFFER_TIMES_TITLE": "Tempi buffer dinamici",
      "BUFFER_TIMES_DESC": "Definisci il tempo extra da bloccare automaticamente in agenda per preparazione e cura post-trattamento.",
      "ACTIVE_STATUS_LABEL": "Stato attivo",
      "ACTIVE_STATUS_DESCRIPTION": "Se attivo, il servizio è disponibile per la prenotazione.",
      "STATUS": "Stato",
      "CANCEL": "Annulla",
      "CREATE": "Crea servizio",
      "UPDATE": "Aggiorna servizio",
      "ERROR_CREATING": "Errore nella creazione del servizio",
      "ERROR_UPDATING": "Errore nell'aggiornamento del servizio"
    },
    "CATEGORIES": {
      "TITLE": "Gestisci categorie servizi",
      "SUBTITLE": "Crea e rimuovi le categorie usate per classificare i servizi.",
      "INPUT_PLACEHOLDER": "Inserisci nome categoria...",
      "LOADING": "Caricamento categorie...",
      "ALREADY_EXISTS": "Questa categoria esiste già",
      "ERROR_LOADING": "Errore nel caricamento delle categorie",
      "ERROR_CREATING": "Errore nella creazione della categoria",
      "ERROR_DELETING": "Errore nell'eliminazione della categoria",
      "DELETE_CONFIRM_TITLE": "Conferma eliminazione",
      "DELETE_CONFIRM_MESSAGE": "Sei sicuro di voler eliminare questa categoria?\n<strong>{{name}}</strong>"
    }
  },

  "COLLABORATORS": {
    "ADD": "Aggiungi collaboratore",
    "SEARCH_PLACEHOLDER": "Cerca collaboratori per nome o servizio...",
    "FILTER_BY": "Filtra per:",
    "FILTER_BY_SERVICES": "Filtra per servizi assegnati",
    "ALL": "Tutti",
    "AVAILABLE": "Disponibile",
    "NOT_AVAILABLE": "Non disponibile",
    "SHOWING": "Visualizzati",
    "OF": "di",
    "COLLABORATORS_COUNT": "collaboratori",
    "NO_COLLABORATORS": "Nessun collaboratore trovato",
    "NO_COLLABORATORS_DESC": "Prova a modificare i filtri o la ricerca.",
    "DELETE_CONFIRM_TITLE": "Conferma eliminazione",
    "DELETE_CONFIRM": "Sei sicuro di voler eliminare questo collaboratore?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Errore nel caricamento dei collaboratori",
    "ERROR_DELETING": "Errore nell'eliminazione del collaboratore",
    "ERROR_SAVE": "Errore nel salvataggio del collaboratore",
    "MODAL": {
      "ADD_TITLE": "Aggiungi nuovo collaboratore",
      "EDIT_TITLE": "Modifica collaboratore",
      "ADD_SUBTITLE": "Crea un nuovo collaboratore e imposta orari e servizi.",
      "EDIT_SUBTITLE": "Aggiorna dati, orari e servizi assegnati.",
      "PROFILE": "Profilo collaboratore",
      "PROFILE_DESC": "Configura dati, orari di lavoro e servizi assegnati.",
      "FIRST_NAME": "Nome",
      "FIRST_NAME_PLACEHOLDER": "es. Elena",
      "LAST_NAME": "Cognome",
      "LAST_NAME_PLACEHOLDER": "es. Rossi",
      "EMAIL": "Email",
      "EMAIL_PLACEHOLDER": "elena.rossi@azienda.com",
      "PHONE": "Telefono",
      "PHONE_PLACEHOLDER": "+39 333 123 4567",
      "ADDRESS": "Indirizzo",
      "ADDRESS_DESC": "Sede in cui opera il collaboratore per i servizi in presenza.",
      "REMOTE": "Remoto",
      "REMOTE_DESCRIPTION": "Se attivo, i servizi sono erogati da remoto (es. videocall): l’indirizzo non si applica.",
      "ADDRESS_STREET": "Via",
      "ADDRESS_STREET_PLACEHOLDER": "es. Via Roma 10",
      "ADDRESS_CITY": "Città",
      "ADDRESS_CITY_PLACEHOLDER": "es. Milano",
      "ADDRESS_PROVINCE": "Provincia",
      "ADDRESS_PROVINCE_PLACEHOLDER": "es. MI",
      "ADDRESS_POSTAL_CODE": "CAP",
      "ADDRESS_POSTAL_CODE_PLACEHOLDER": "es. 20100",
      "ADDRESS_COUNTRY": "Stato",
      "ADDRESS_COUNTRY_PLACEHOLDER": "es. Italia",
      "ASSIGNED_SERVICES": "Servizi assegnati",
      "ASSIGNED_SERVICES_PLACEHOLDER": "Seleziona i servizi da assegnare...",
      "STATUS": "Stato disponibilità",
      "STATUS_DESCRIPTION": "Se disponibile, il collaboratore può essere assegnato alle prenotazioni.",
      "SAVE": "Salva collaboratore",
      "UPDATE": "Aggiorna collaboratore"
    },
    "WEEKDAYS": {
      "MONDAY": "Lunedì",
      "TUESDAY": "Martedì",
      "WEDNESDAY": "Mercoledì",
      "THURSDAY": "Giovedì",
      "FRIDAY": "Venerdì",
      "SATURDAY": "Sabato",
      "SUNDAY": "Domenica"
    },
    "WORKING_HOURS": {
      "LABEL": "Orari di lavoro",
      "DESC": "Definisci quando questo collaboratore è disponibile per le prenotazioni.",
      "EDIT": "Modifica orari",
      "ADD": "Aggiungi orari",
      "TITLE": "Imposta orari di lavoro",
      "SUBTITLE": "Definisci orario settimanale e pause.",
      "QUICK_APPLY": "Applica rapidamente:",
      "EVERY_DAY": "Ogni giorno",
      "WEEKDAYS": "Feriali (lun–ven)",
      "WEEKENDS": "Weekend (sab–dom)",
      "ADD_RANGE": "Aggiungi fascia",
      "CLOSED": "Chiuso",
      "SAVE_HOURS": "Salva orari",
      "INVALID_RANGE": "Fascia non valida per {{day}}: l'ora di inizio deve essere prima della fine.",
      "OVERLAP": "Fasce sovrapposte per {{day}}.",
      "DISCARD_CONFIRM": "Annullare le modifiche?",
      "SUMMARY_MON_FRI": "Lun–Ven",
      "SUMMARY_EVERY_DAY": "Ogni giorno",
      "SUMMARY_DAYS": "{{count}} giorni / settimana"
    }
  },

  "KNOWLEDGE_BASE": {
    "TITLE": "Knowledge Base",
    "TAB_FAQS": "FAQ",
    "TAB_LINKS": "Link esterni",
    "DELETE_FAQ_CONFIRM_TITLE": "Conferma eliminazione",
    "DELETE_FAQ_CONFIRM_MESSAGE": "Vuoi davvero eliminare questa FAQ?\n<strong>{{question}}</strong>",
    "DELETE_LINK_CONFIRM_TITLE": "Conferma eliminazione",
    "DELETE_LINK_CONFIRM_MESSAGE": "Vuoi davvero eliminare questo link?\n<strong>{{title}}</strong>",
    "SEARCH_FAQS": "Cerca FAQ...",
    "SEARCH_LINKS": "Cerca link...",
    "ADD_FAQ": "Aggiungi FAQ",
    "ADD_LINK": "Aggiungi link",
    "EMPTY_FAQS_TITLE": "Nessuna FAQ trovata",
    "EMPTY_FAQS_DESC": "Nessuna domanda corrisponde alla ricerca. Prova ad aggiungerne una nuova o modifica i termini.",
    "EMPTY_LINKS_TITLE": "Nessun link trovato",
    "EMPTY_LINKS_DESC": "Inizia a costruire la knowledge base aggiungendo link a risorse esterne.",
    "MODAL": {
      "TITLE_ADD_FAQ": "Aggiungi nuova FAQ",
      "TITLE_EDIT_FAQ": "Modifica FAQ",
      "TITLE_ADD_LINK": "Aggiungi nuovo link",
      "TITLE_EDIT_LINK": "Modifica link",
      "FAQ_SUBTITLE": "Insegna all'AI una risposta specifica per il tuo business.",
      "LINK_SUBTITLE": "Fornisci una risorsa esterna che l'AI può consultare.",
      "FAQ_DETAILS": "Dettagli FAQ",
      "LINK_INFO": "Informazioni link",
      "QUESTION": "Domanda",
      "QUESTION_PLACEHOLDER": "es. Quali sono gli orari di apertura?",
      "ANSWER": "Risposta",
      "ANSWER_PLACEHOLDER": "Inserisci la risposta dettagliata per l'AI...",
      "TITLE": "Titolo",
      "TITLE_PLACEHOLDER": "es. Listino 2024",
      "URL": "URL",
      "URL_PLACEHOLDER": "https://esempio.com",
      "SHORT_DESCRIPTION": "Descrizione breve",
      "SHORT_DESCRIPTION_PLACEHOLDER": "Spiega all'AI cosa contiene questo link...",
      "CANCEL": "Annulla",
      "SAVE_CHANGES": "Salva modifiche",
      "ADD_FAQ": "Aggiungi FAQ",
      "ADD_LINK": "Aggiungi link",
      "ERROR_SAVE": "Impossibile salvare. Riprova."
    },
    "ERROR_LOADING_FAQ": "Errore nel caricamento delle FAQ",
    "ERROR_LOADING_LINKS": "Errore nel caricamento dei link",
    "ERROR_DELETE_FAQ": "Errore nell'eliminazione della FAQ",
    "ERROR_DELETE_LINK": "Errore nell'eliminazione del link"
  },

  "ERRORS": {
    "AUTH_INVALID_CREDENTIALS": "Email o password non validi",
    "AUTH_TOKEN_EXPIRED": "La tua sessione è scaduta, effettua nuovamente l'accesso",
    "AUTH_UNAUTHORIZED": "Non sei autorizzato ad accedere a questa risorsa",
    "AUTH_EMAIL_ALREADY_EXISTS": "Esiste già un account con questa email",
    "AUTH_FORBIDDEN": "Non hai i permessi per eseguire questa azione",

    "TENANT_NOT_FOUND": "Tenant non trovato",
    "TENANT_ALREADY_EXISTS": "Esiste già un tenant con questo nome",
    "TENANT_NAME_TAKEN": "Questo nome è già in uso",
    "TENANT_CREATION_FAILED": "Errore durante la creazione del tenant",
    "TENANT_UPDATE_FORBIDDEN": "Solo i super admin possono modificare i tenant",
    "TENANT_DELETE_FORBIDDEN": "Solo i super admin possono eliminare i tenant",
    "TENANT_ACCESS_DENIED": "Accesso negato a questo tenant",
    "TENANT_INVITE_FORBIDDEN": "Solo i super admin o gli admin del tenant possono invitare utenti",

    "USER_NOT_FOUND": "Utente non trovato",
    "USER_EMAIL_INVALID": "Indirizzo email non valido",
    "USER_ROLE_INVALID": "Ruolo utente non valido",
    "USER_UPDATE_FORBIDDEN": "Non puoi modificare questo utente",
    "USER_ASSIGN_FORBIDDEN": "Solo i super admin possono assegnare utenti ai tenant",
    "USER_REMOVE_FORBIDDEN": "Solo i super admin possono rimuovere utenti dai tenant",

    "INVITE_NOT_FOUND": "Invito non trovato",
    "INVITE_EXPIRED": "Questo invito è scaduto",
    "INVITE_ALREADY_USED": "Questo invito è già stato utilizzato",
    "INVITE_CREATION_FAILED": "Errore durante la creazione dell'invito",
    "INVITE_EMAIL_SEND_FAILED": "Impossibile inviare l'email di invito. L'invito è stato annullato. Verifica chiave API Resend, ID dei template e configurazione del mittente.",

    "CONTACT_NOT_FOUND": "Contatto non trovato",
    "CONTACT_ACCESS_DENIED": "Accesso negato a questo contatto",
    "CONTACT_CREATION_FORBIDDEN": "Solo admin o super_admin possono creare contatti",
    "CONTACT_UPDATE_FORBIDDEN": "Solo admin o super_admin possono modificare contatti",
    "CONTACT_DELETE_FORBIDDEN": "Solo admin o super_admin possono eliminare contatti",
    "CONTACT_DUPLICATE_EMAIL": "Un contatto con questa email esiste già nel tuo tenant",

    "VALIDATION_REQUIRED_FIELD": "Questo campo è obbligatorio",
    "VALIDATION_INVALID_EMAIL": "Formato email non valido",
    "VALIDATION_MIN_LENGTH": "Il valore è troppo corto",
    "VALIDATION_MAX_LENGTH": "Il valore è troppo lungo",

    "SYSTEM_INTERNAL_ERROR": "Si è verificato un errore imprevisto",
    "SYS_001": "Errore sconosciuto",
    "SYSTEM_DATABASE_ERROR": "Operazione database fallita",
    "NETWORK_ERROR": "Errore di connessione al server"
  },

  "ERROR_MODAL": {
    "TITLE": "Errore",
    "HEADING": "Qualcosa è andato storto",
    "STATUS": "Stato",
    "ERROR_CODE": "Codice errore",
    "MESSAGE": "Messaggio",
    "PATH": "Path",
    "TIMESTAMP": "Data e ora",
    "DETAILS": "Dettagli",
    "TECHNICAL_DETAILS": "Dettagli tecnici",
    "NO_MESSAGE": "Nessun messaggio",
    "CLOSE": "Chiudi"
  },

  "SUCCESS": {
    "TENANT_CREATED": "Tenant creato con successo",
    "TENANT_UPDATED": "Tenant aggiornato con successo",
    "TENANT_DELETED": "Tenant eliminato con successo",
    "USER_INVITED": "Invito inviato con successo",
    "USER_UPDATED": "Utente aggiornato con successo",
    "USER_ASSIGNED": "Utente assegnato al tenant con successo",
    "USER_REMOVED": "Utente rimosso dal tenant con successo",
    "INVITE_ACCEPTED": "Invito accettato con successo"
  },

  "INVITE_ACCEPT": {
    "TITLE": "Accetta Invito",
    "SUBTITLE_LOADING": "Completando la registrazione...",
    "SUBTITLE_VALID": "Completa il tuo profilo per unirti al tenant",
    "SUBTITLE_INVALID": "Inserisci il link di invito ricevuto via email",
    "VALIDATING": "Validazione invito...",
    "INVITED_BY": "Sei stato invitato da",
    "THIS_TENANT": "questo tenant",
    "EMAIL": "Email",
    "ROLE": "Ruolo",
    "FIRST_NAME": "Nome",
    "LAST_NAME": "Cognome",
    "PASSWORD": "Password",
    "CONFIRM_PASSWORD": "Conferma password",
    "PHONE_OPTIONAL": "Telefono (opzionale)",
    "PASSWORD_MISMATCH": "Le password non coincidono.",
    "ACCEPTING": "Accettazione in corso...",
    "ACCEPT_BUTTON": "Accetta Invito",
    "SUCCESS_REDIRECT": "Invito accettato con successo! Reindirizzamento al dashboard...",
    "BACK_TO_LOGIN": "Torna al login",
    "INVALID_TOKEN": "Token invito non valido",
    "INVITE_INVALID_OR_EXPIRED": "Invito non valido o scaduto",
    "VALIDATION_ERROR": "Errore nella validazione dell'invito",
    "ACCEPT_ERROR": "Errore nell'accettazione dell'invito",
    "ACCOUNT_CREATE_ERROR": "Errore nella creazione dell'account",
    "LOAD_USER_ERROR": "Account creato ma non è stato possibile caricare il profilo. Prova ad accedere."
  },

  "FIREBASE_AUTH": {
    "EMAIL_ALREADY_IN_USE": "Questa email è già in uso",
    "WEAK_PASSWORD": "La password deve avere almeno 6 caratteri",
    "INVALID_EMAIL": "Indirizzo email non valido",
    "TOO_MANY_ATTEMPTS": "Troppi tentativi. Riprova più tardi",
    "OPERATION_NOT_ALLOWED": "Questo metodo di accesso non è abilitato",
    "USER_DISABLED": "Questo account è stato disabilitato",
    "GENERIC": "Errore di autenticazione. Riprova",
    "INVALID_CREDENTIAL": "Email o password non validi",
    "NETWORK_ERROR": "Errore di rete. Controlla la connessione e riprova",
    "POPUP_CLOSED": "Accesso annullato",
    "ACCOUNT_EXISTS_DIFFERENT_CREDENTIAL": "Esiste già un account con questa email con un altro metodo di accesso",
    "REQUIRES_RECENT_LOGIN": "Esci e accedi di nuovo per continuare",
    "EXPIRED_ACTION_CODE": "Questo link è scaduto",
    "INVALID_ACTION_CODE": "Questo link non è valido o è già stato usato",
    "EMAIL_CHANGE_NEEDS_VERIFICATION": "Verifica il tuo nuovo indirizzo email",
    "UNKNOWN_ERROR": "Errore sconosciuto. Riprova"
  },
  "AGENDA": {
    "WEEKDAYS_SHORT": {
      "SUNDAY": "Dom",
      "MONDAY": "Lun",
      "TUESDAY": "Mar",
      "WEDNESDAY": "Mer",
      "THURSDAY": "Gio",
      "FRIDAY": "Ven",
      "SATURDAY": "Sab"
    },
    "WEEKDAY_LETTERS": "L,M,M,G,V,S,D",
    "MONTHS": {
      "JANUARY": "Gennaio",
      "FEBRUARY": "Febbraio",
      "MARCH": "Marzo",
      "APRIL": "Aprile",
      "MAY": "Maggio",
      "JUNE": "Giugno",
      "JULY": "Luglio",
      "AUGUST": "Agosto",
      "SEPTEMBER": "Settembre",
      "OCTOBER": "Ottobre",
      "NOVEMBER": "Novembre",
      "DECEMBER": "Dicembre"
    },
    "NO_AVAILABLE_SLOTS": "Nessun orario",
    "SLOT_BOOKED": "Già prenotato",
    "NEW_APPOINTMENT": "Nuovo appuntamento",
    "SEARCH_PLACEHOLDER": "Cerca per titolo, cliente o note...",
    "FILTER_BY": "Filtra per:",
    "ALL": "Tutti",
    "CONFIRMED": "Confermati",
    "PENDING": "In attesa",
    "COMPLETED": "Completati",
    "CANCELLED": "Annullati",
    "CANCELLED_BY_CLIENT": "Annullati dal cliente",
    "LIST": "Lista",
    "CALENDAR": "Calendario",
    "TODAY": "Oggi",
    "VIEW_DAY": "Giorno",
    "VIEW_WEEK": "Settimana",
    "VIEW_MONTH": "Mese",
    "ADVANCED_FILTERS": "Filtri avanzati",
    "DATE_FROM": "Data da",
    "DATE_TO": "Data a",
    "SERVICE": "Servizio",
    "CLIENT": "Cliente",
    "ALL_SERVICES": "Tutti i servizi",
    "ALL_CLIENTS": "Tutti i clienti",
    "RESET_FILTERS": "Reimposta filtri",
    "APPLY_FILTERS": "Applica filtri",
    "NO_APPOINTMENTS": "Nessun appuntamento trovato per questo filtro.",
    "EDIT": "Modifica",
    "COMPLETE": "Completa",
    "NO_SHOW": "Assente",
    "CANCELLED_BY_CLIENT_LABEL": "Annullato dal cliente",
    "NO_SHOW_LABEL": "Non presentato (no-show)",
    "NO_SHOW_CONFIRM_TITLE": "Segna come assente",
    "NO_SHOW_CONFIRM_MESSAGE": "Confermi di segnare questo appuntamento come no-show? Il cliente non si è presentato.",
    "NO_SHOW_CONFIRM_YES": "Segna assente",
    "CANCEL": "Annulla",
    "CONFIRM": "Conferma",
    "ERROR_LOADING": "Errore nel caricamento degli appuntamenti",
    "DELETE_CONFIRM_TITLE": "Elimina appuntamento",
    "DELETE_CONFIRM_MESSAGE": "Sei sicuro di voler eliminare questo appuntamento? L'operazione non può essere annullata.",
    "DELETE_CONFIRM_YES": "Elimina",
    "ERROR_UPDATE": "Errore nell'aggiornamento dell'appuntamento",
    "ERROR_SAVE": "Errore nel salvataggio",
    "CANCEL_CONFIRM_TITLE": "Annulla appuntamento",
    "CANCEL_CONFIRM_MESSAGE": "Sei sicuro di voler annullare questo appuntamento?",
    "CANCEL_CONFIRM_YES": "Sì, annulla",
    "MODAL": {
      "ADD_TITLE": "Nuovo appuntamento",
      "EDIT_TITLE": "Modifica appuntamento",
      "ADD_SUBTITLE": "Programma un nuovo appuntamento",
      "EDIT_SUBTITLE": "Aggiorna i dettagli dell'appuntamento",
      "SERVICE": "Servizio",
      "SELECT_SERVICE": "Seleziona un servizio",
      "SEARCH_SERVICE": "Cerca servizio...",
      "NO_SERVICES": "Nessun servizio trovato",
      "TITLE": "Titolo",
      "TITLE_PLACEHOLDER": "es. Taglio e piega",
      "CLIENT": "Cliente",
      "SELECT_CLIENT": "Seleziona un cliente",
      "SEARCH_CLIENT": "Cerca cliente...",
      "NO_CLIENTS": "Nessun cliente trovato",
      "COLLABORATOR": "Collaboratore (opzionale)",
      "SELECT_COLLABORATOR": "Seleziona un collaboratore",
      "SEARCH_COLLABORATOR": "Cerca collaboratore...",
      "NO_COLLABORATORS": "Nessun collaboratore trovato",
      "STATUS": "Stato",
      "DATE": "Data",
      "START_TIME": "Ora inizio",
      "END_TIME": "Ora fine",
      "NOTES": "Note (opzionale)",
      "NOTES_PLACEHOLDER": "Aggiungi note interne...",
      "SAVE": "Salva modifiche",
      "CREATE": "Crea appuntamento"
    },
    "STATUS": {
      "CONFIRMED": "Confermato",
      "PENDING": "In attesa",
      "COMPLETED": "Completato",
      "CANCELLED": "Annullato",
      "CANCELLED_BY_CLIENT": "Annullato dal cliente",
      "NO_SHOW": "No-show"
    },
    "COMPLETED_LABEL": "Completato",
    "FORMS": {
      "BOOKING_FORM": "Form di prenotazione",
      "RESPONSES_TITLE": "Risposte del form",
      "RESPONSES_SUBTITLE": "Visualizza le risposte compilate per questo appuntamento",
      "LINK_TITLE": "Link pubblico al form",
      "COPY_LINK": "Copia link",
      "NO_SUBMISSION": "Per questo appuntamento non è ancora stato generato alcun form.",
      "STATUS_PENDING": "Form non ancora compilato",
      "STATUS_SUBMITTED": "Form compilato",
      "ANSWERS_TITLE": "Risposte inviate",
      "PRIVACY_TITLE": "Privacy & Policy",
      "PRIVACY_ACCEPTED_AT": "Accettata il",
      "NO_ANSWER": "Nessuna risposta fornita",
      "VIEW_RESPONSES": "Vedi risposte",
      "NO_FORM_FOR_APPOINTMENT": "Nessun form di prenotazione associato a questo appuntamento.",
      "ERROR_LOADING_FORM": "Errore nel caricamento del form",
      "ERROR_LOADING_SUBMISSION": "Errore nel caricamento delle risposte del form",
      "ERROR_NO_APPOINTMENT": "Seleziona un appuntamento con form di prenotazione per vedere le risposte."
    }
  },

  "FORMS": {
    "PUBLIC": {
      "NOT_FOUND": "Il form non è stato trovato o il link non è valido.",
      "ALREADY_SUBMITTED": "Hai già compilato questo form. Grazie!",
      "ANSWER_PLACEHOLDER": "Scrivi la tua risposta...",
      "SUBMIT": "Invia form",
      "NEXT": "Avanti",
      "BACK": "Torna indietro",
      "STEP_1_LABEL": "Dati e richieste",
      "STEP_2_LABEL": "Scegli orario",
      "PRIVACY_STEP_LABEL": "Privacy & Policy",
      "PRIVACY_ACCEPT_LABEL": "Ho letto e accetto la Privacy & Policy",
      "SUBMITTED_ANSWERS": "Risposte inviate",
      "SUMMARY_TITLE": "Riepilogo della tua richiesta",
      "YOUR_ANSWERS": "Le tue risposte",
      "YOUR_BOOKING": "La tua prenotazione",
      "CANCEL_BOOKING": "Annulla prenotazione",
      "BOOKING_CANCELLED_SUCCESS": "Prenotazione annullata con successo",
      "BOOKING_CANCELLED_ERROR": "Impossibile annullare la prenotazione",
      "BOOKING_DATE": "Data",
      "BOOKING_TIME": "Orario",
      "BOOKING_SERVICE": "Servizio",
      "BOOKING_WITH": "Con",
      "BOOKING_DURATION": "Durata",
      "BOOKING_CONTEXT_TITLE": "Dettagli prenotazione",
      "BOOKING_CONTEXT_REGION": "Riepilogo servizio e collaboratore",
      "BOOKING_CONFIRM_TITLE": "Conferma prenotazione",
      "CALENDAR_LOADING": "Caricamento orari...",
      "BOOKING_SUCCESS_TITLE": "Prenotazione confermata.",
      "BOOKING_SUCCESS_MESSAGE": "Puoi chiudere questa pagina. Un messaggio di riepilogo è stato inviato nella chat.",
      "PREFILLED_SLOT_NOTICE": "Slot fissato dall'operatore: {{date}} {{startTime}}–{{endTime}}",
      "BOOK_CTA": "Prenota",
      "CONFIRM_CTA": "Conferma",
      "CONFIRMING": "Conferma in corso...",
      "BOOKING_NOTE_LABEL": "Note (opzionale)",
      "BOOKING_NOTE_PLACEHOLDER": "Aggiungi eventuali note per l'appuntamento",
      "DURATION_FMT_MINUTES": "{{m}} minuti",
      "DURATION_FMT_ONE_HOUR": "1 ora",
      "DURATION_FMT_HOURS": "{{h}} ore",
      "DURATION_FMT_ONE_HOUR_AND_MINUTES": "1 ora e {{m}} minuti",
      "DURATION_FMT_HOURS_AND_MINUTES": "{{h}} ore e {{m}} minuti",
      "ERROR_LOADING": "Errore nel caricamento del form",
      "ERROR_SUBMITTING": "Errore durante l'invio del form",
      "REQUIRED_FIELD": "Questo campo è obbligatorio",
      "INVALID_TOKEN": "Questo link al form non è valido o è scaduto.",
      "SUBMIT_SUCCESS": "Grazie! Il form è stato inviato con successo.",
      "ERROR_LOADING_SLOTS": "Impossibile caricare gli orari disponibili.",
      "ERROR_BOOKING": "Impossibile completare la prenotazione. Riprova."
    }
  },

  "WIDGET_DEMO": {
    "TITLE": "Demo Widget Chat",
    "DESCRIPTION": "Questa è una pagina di esempio per testare il widget di chat. Il widget appare in basso a destra.",
    "DEMO_PAGE_TITLE": "Pagina Demo",
    "DEMO_PAGE_DESCRIPTION": "Questa pagina simula un sito web con il widget integrato. Puoi interagire con il chatbot cliccando l'icona in basso a destra.",
    "ERROR_NO_CODE": "Nessun widget code disponibile. Genera un widget code dalle Settings.",
    "ERROR_NOT_GENERATED": "Widget code non generato. Genera un widget code dalle Settings.",
    "ERROR_LOADING": "Errore durante il caricamento del widget. Verifica che il file widget sia disponibile.",
    "SUCCESS_LOADED": "Widget caricato con successo!",
    "SUCCESS_MESSAGE": "Clicca l'icona in basso a destra per aprire la chat e testare il widget.",
    "LOADING": "Caricamento widget...",
    "HOW_TO_TEST": "Come testare:",
    "STEP_1": "Clicca l'icona del widget in basso a destra",
    "STEP_2": "La finestra chat si aprirà",
    "STEP_3": "Scrivi un messaggio per testare la conversazione",
    "STEP_4": "Verifica che le risposte del chatbot funzionino correttamente",
    "NOTE": "Nota: Questa è una pagina demo. Per integrare il widget sul tuo sito, copia lo snippet HTML dalle Settings → Integrations.",
    "GO_TO_SETTINGS": "Vai alle Settings"
  },

  "WIDGET": {
    "CHAT_TITLE": "Chat",
    "INPUT_PLACEHOLDER": "Scrivi il tuo messaggio...",
    "SEND_BUTTON": "Invia",
    "CLOSE_BUTTON": "Chiudi chat",
    "OPEN_CHAT": "Apri chat",
    "TYPING": "Sta scrivendo...",
    "ERROR_SENDING": "Mi dispiace, si è verificato un errore. Riprova.",
    "ERROR_VALIDATION": "Widget code non valido o tenant non attivo"
  },

  "WIDGET_TEST": {
    "TITLE": "Test Integrazione Widget",
    "DESCRIPTION": "Inserisci un widget code per testare l'integrazione del chatbot sul tuo sito.",
    "CONFIGURATION_TITLE": "Configurazione Widget",
    "CONFIGURATION_DESCRIPTION": "Inserisci il codice widget per validarlo e caricare il widget di test",
    "WIDGET_CODE_LABEL": "Widget Code",
    "WIDGET_CODE_PLACEHOLDER": "Inserisci il codice widget (es. ABC123XYZ)",
    "WIDGET_CODE_REQUIRED": "Il widget code è obbligatorio",
    "LOADING": "Caricamento...",
    "LOAD_WIDGET": "Carica Widget",
    "ERROR_PREFIX": "Errore:",
    "VALID_WIDGET": "Widget valido!",
    "TENANT": "Tenant",
    "SNIPPET_TITLE": "Snippet HTML",
    "SNIPPET_DESCRIPTION": "Copia questo snippet e incollalo nel tuo sito web per integrare il widget",
    "COPY_SNIPPET": "Copia Snippet",
    "HOW_TO_TITLE": "Come usare il widget",
    "HOW_TO_STEP_1": "Genera o ottieni il tuo widget code dalla sezione Settings",
    "HOW_TO_STEP_2": "Incolla lo snippet HTML nella sezione <code>&lt;head&gt;</code> o prima della chiusura <code>&lt;/body&gt;</code> del tuo sito",
    "HOW_TO_STEP_3": "Il widget apparirà automaticamente come icona in basso a destra",
    "HOW_TO_STEP_4": "Gli utenti potranno cliccare l'icona per aprire la chat",
    "NOTE_PREFIX": "Nota:",
    "NOTE_TEXT": "Il widget viene caricato dinamicamente su questa pagina per test. Assicurati che l'URL del widget JS sia accessibile pubblicamente quando lo integri sul tuo sito.",
    "ERROR_SUSPENDED": "Questo widget è stato sospeso.",
    "ERROR_BLOCKED": "Questo widget è stato bloccato.",
    "ERROR_INVALID": "Codice widget non valido o sconosciuto.",
    "ERROR_LOAD": "Impossibile caricare il widget. Verifica il codice e riprova.",
    "ERROR_SCRIPT": "Impossibile caricare lo script del widget. Verifica che il file sia disponibile."
  },

  "CONVERSATIONS": {
    "SEARCH_PLACEHOLDER": "Cerca messaggi, clienti o tag...",
    "FILTER_BY": "Filtra per:",
    "FILTERS": {
      "ALL": "Tutti",
      "UNREAD": "Non letti",
      "PENDING": "In attesa",
      "RESOLVED": "Risolti"
    },
    "CLIENT_PROFILE": {
      "TITLE": "Profilo Cliente",
      "SEE_CONTACT": "Vedi contatto",
      "FULL_NAME": "Nome Completo",
      "EMAIL_ADDRESS": "Indirizzo Email",
      "PHONE_NUMBER": "Numero di Telefono",
      "TAGS": "Tag",
      "SELECT_CONVERSATION": "Seleziona una conversazione per visualizzare i dettagli del cliente."
    },
    "AI_SUMMARY": {
      "TITLE": "Riepilogo AI Conversazione",
      "NO_SUMMARY": "Nessun riepilogo disponibile per questa conversazione."
    },
    "CHAT": {
      "SELECT_CONVERSATION": "Seleziona una conversazione dalla lista per iniziare a chattare.",
      "LAST_VISIT": "Ultima visita",
      "AI_MODE": "Modalità AI",
      "AI_MODE_ACTIVE_NOTICE": "La Modalità AI è attiva. Il chatbot risponderà automaticamente ai messaggi in arrivo.",
      "REPLY_PLACEHOLDER": "Scrivi la tua risposta… (Invio per inviare, Shift+Invio per andare a capo)",
      "SENDING": "Invio in corso..."
    },
    "CHANNELS": {
      "TELEGRAM": "Telegram",
      "WHATSAPP": "WhatsApp",
      "WEBCHAT": "Chat Web"
    },
    "ERROR_LOAD_LIST": "Impossibile caricare le conversazioni.",
    "ERROR_LOAD_DETAILS": "Impossibile caricare questa conversazione.",
    "ERROR_SEND_MESSAGE": "Impossibile inviare il messaggio.",
    "ERROR_AI_MODE": "Impossibile aggiornare la modalità AI."
  },
  "FLOWS": {
    "ADD_FLOW": "Aggiungi Flow",
    "NO_FLOWS": "Nessun flow configurato.",
    "UNNAMED": "Flow senza nome",
    "SHOWING": "Mostrati",
    "FLOWS_LABEL": "flow",
    "ERROR_LOADING": "Impossibile caricare i flow.",
    "ERROR_CREATE": "Impossibile creare il flow.",
    "ERROR_UPDATE": "Impossibile aggiornare il flow.",
    "ERROR_DELETE": "Impossibile eliminare il flow.",
    "ERROR_STATUS": "Impossibile aggiornare lo stato del flow.",
    "ERROR_TEST": "Impossibile inviare il test.",
    "ERROR_LOADING_EXECUTIONS": "Impossibile caricare le esecuzioni del flow.",
    "CREATED": "Flow creato con successo.",
    "UPDATED": "Flow aggiornato con successo.",
    "DELETED": "Flow eliminato con successo.",
    "DELETE_CONFIRM_TITLE": "Elimina flow",
    "DELETE_CONFIRM": "Eliminare questo flow?\n<strong>{{name}}</strong>",
    "STATUS_UPDATED": "Stato del flow aggiornato.",
    "TEST_SENT": "Messaggi di test inviati con successo.",
    "COLUMNS": {
      "NAME": "Nome",
      "TRIGGER": "Evento",
      "TIMING": "Tempistica",
      "STATUS": "Stato"
    },
    "TRIGGERS": {
      "APPOINTMENT_REQUESTED": "Richiesta appuntamento",
      "APPOINTMENT_CONFIRMED": "Appuntamento confermato",
      "APPOINTMENT_UPDATED": "Appuntamento modificato",
      "APPOINTMENT_CANCELLED": "Appuntamento annullato",
      "APPOINTMENT_CANCELLED_BY_CLIENT": "Appuntamento annullato dal cliente",
      "APPOINTMENT_COMPLETED": "Appuntamento completato",
      "APPOINTMENT_NO_SHOW": "Appuntamento no-show",
      "APPOINTMENT_REMINDER": "Promemoria appuntamento (slot)",
      "CONVERSATION_NO_RESPONSE": "Nessuna risposta dopo messaggio in uscita",
      "FORM_NOT_COMPLETED": "Modulo lasciato incompleto"
    },
    "TIMING": {
      "BEFORE": "Prima",
      "AFTER": "Dopo"
    },
    "UNITS": {
      "MINUTES": "minuti",
      "HOURS": "ore",
      "DAYS": "giorni"
    },
    "STATUS": {
      "ACTIVE": "Attivo",
      "PAUSED": "In pausa",
      "AUTO_DISABLED": "Disattivato"
    },
    "EXECUTION_STATUS": {
      "PENDING": "In attesa",
      "PROCESSING": "In lavorazione",
      "SENT": "Completato",
      "FAILED": "Errore",
      "CANCELLED": "Annullato"
    },
    "TABS": {
      "DEFINITIONS": "Flow",
      "EXECUTIONS": "Esecuzioni"
    },
    "EXECUTIONS": {
      "NO_EXECUTIONS": "Nessuna esecuzione trovata.",
      "FILTER_ALL": "Tutti",
      "OPEN_DETAILS": "Apri dettagli",
      "DETAILS_TITLE": "Dettagli esecuzione flow",
      "COLUMNS": {
        "FLOW": "Flow",
        "SCHEDULED_AT": "Schedulato per",
        "RUN_AT": "Eseguito alle",
        "RETRIES": "Retry",
        "TARGET": "Destinatario",
        "ERROR": "Errore"
      }
    },
    "CHANNEL": {
      "AUTO": "Preferito del cliente"
    },
    "MODAL": {
      "ADD_TITLE": "Crea Flow",
      "EDIT_TITLE": "Modifica Flow",
      "SUBTITLE": "Configura un messaggio automatico per i tuoi clienti.",
      "GENERAL": "Generale",
      "TITLE": "Titolo",
      "TITLE_PLACEHOLDER": "es. Reminder appuntamento dopo 24h",
      "DESCRIPTION": "Descrizione",
      "DESCRIPTION_PLACEHOLDER": "Note interne (opzionale)",
      "TRIGGER": "Evento trigger",
      "TRIGGER_PLACEHOLDER": "Seleziona uno o più trigger...",
      "TIMING": "Tempistica",
      "BEFORE_AFTER": "Prima / Dopo",
      "NUMBER": "Numero",
      "TIME_UNIT": "Unità",
      "MESSAGE": "Messaggio",
      "MESSAGE_TEMPLATE": "Messaggio riferimento",
      "MESSAGE_PLACEHOLDER": "Ciao {name}, il tuo appuntamento è il {date} alle {start_time}.",
      "PLACEHOLDER_SELECT_LABEL": "Inserisci segnaposto",
      "ADD_PLACEHOLDER": "Aggiungi",
      "PLACEHOLDERS_HINT": "Segnaposto: {name}, {last_name}, {full_name}, {date}, {start_time}, {end_time}, {treatment}, {phone}, {mail}, {form_link}, {form_name}, {conversation_link}, {conversation_id}",
      "CHANNEL": "Canale di invio",
      "CHANNEL_OVERRIDE": "Canale",
      "CREATE": "Crea",
      "SAVE": "Salva"
    },
    "TEST": {
      "TITLE": "Invia Test",
      "SUBTITLE": "Invia un messaggio di test immediato ai membri del team selezionati.",
      "SELECT_RECIPIENTS": "Seleziona destinatari...",
      "SEND": "Invia Test"
    }
  },
  "FLOOR_PLAN": {
    "ROOMS": "Sale",
    "ROOM_DRAG_HANDLE_ARIA": "Trascina per riordinare la sala",
    "ERROR_REORDER_ROOMS": "Impossibile salvare l'ordine delle sale.",
    "ROOM_BLOCK": "Blocca sala",
    "ROOM_BLOCK_CONFIRM_TITLE": "Bloccare la sala?",
    "ROOM_BLOCK_CONFIRM_MESSAGE": "La sala «{{name}}» non accetterà prenotazioni né spostamenti finché resta bloccata. I tavoli e le combinazioni resteranno visibili ma disabilitati.",
    "ROOM_UNBLOCK": "Sblocca sala",
    "ROOM_UNBLOCK_CONFIRM_TITLE": "Riattivare la sala?",
    "ROOM_UNBLOCK_CONFIRM_MESSAGE": "La sala «{{name}}» tornerà disponibile per prenotazioni e spostamenti.",
    "ROOM_BLOCKED_BADGE": "Bloccata",
    "ROOM_BLOCKED_HINT": "Sala bloccata: nessuna prenotazione né spostamento verso questa sala. I tavoli e le combinazioni restano visibili ma disabilitati.",
    "ROOM_BLOCKED_TOAST": "Sala bloccata.",
    "ROOM_UNBLOCKED_TOAST": "Sala sbloccata.",
    "ERROR_TOGGLE_ROOM_BLOCK": "Impossibile aggiornare lo stato della sala.",
    "ROOM_NAME": "Nome sala",
    "ROOM_DESCRIPTION": "Descrizione",
    "ROOM_COLOR": "Colore sala",
    "ADD_ROOM_TITLE": "Crea sala",
    "EDIT_ROOM_TITLE": "Modifica sala",
    "SAVE_ROOM": "Salva sala",
    "ADD_SECTION": "Aggiungi",
    "ADD_PANEL_TITLE": "Aggiungi in sala",
    "ADD_PANEL_TABLE": "Tavolo",
    "ADD_PANEL_COMPONENT": "Componente",
    "ADD_TABLE_BLOCK": "Aggiungi tavolo",
    "ADD_NEW_TABLE": "Aggiungi nuovo tavolo",
    "EDIT_TABLE_TITLE": "Modifica tavolo",
    "SAVE_TABLE": "Salva tavolo",
    "ADD_COMPONENT_BLOCK": "Aggiungi componente",
    "ADD_COMPONENT": "Aggiungi componente",
    "ADD_NEW_COMPONENT": "Aggiungi nuovo componente",
    "EDIT_COMPONENT_TITLE": "Modifica componente",
    "SAVE_COMPONENT": "Salva componente",
    "COMPONENT_NAME": "Nome",
    "COMPONENT_NAME_PLACEHOLDER": "es. Ingresso principale, Porta cucina",
    "COMPONENT_TYPE": "Tipo",
    "COMPONENT_COLOR": "Colore",
    "CREATE_COMPONENT": "Crea",
    "COMPONENT_CREATED": "Componente creato con successo.",
    "COMPONENT_UPDATED": "Componente aggiornato con successo.",
    "COMPONENT_DELETED": "Componente eliminato con successo.",
    "COMPONENT_TYPE_DOOR": "Porta",
    "COMPONENT_TYPE_WINDOW": "Finestra",
    "COMPONENT_TYPE_BATHROOM": "Bagno",
    "COMPONENT_TYPE_KITCHEN": "Cucina",
    "COMPONENT_TYPE_BAR": "Bar",
    "COMPONENT_TYPE_STAIRS": "Scale",
    "COMPONENT_TYPE_PILLAR": "Colonna",
    "COMPONENT_TYPE_GENERIC": "Generico",
    "ADD_ROOM": "Aggiungi sala",
    "NO_ROOMS": "Nessuna sala",
    "TABLES": "tavoli",
    "SEATS": "coperti",
    "EDIT_LAYOUT": "Modifica layout",
    "VIEW_MODE": "Modalita visualizzazione",
    "SEARCH_TABLE": "Cerca tavolo",
    "FILTER_ALL": "Tutti gli stati",
    "RESET_VIEW": "Reset vista",
    "ZOOM_IN": "Zoom avanti",
    "ZOOM_OUT": "Zoom indietro",
    "ZOOM_LEVEL": "Zoom: {{pct}}% (puoi usare anche la rotella del mouse sul canvas)",
    "TABLE_NAME": "Nome tavolo",
    "LAYOUT_TOOLS": "Strumenti layout",
    "TABLE_NAME_LABEL": "Nome tavolo",
    "TABLE_NAME_PLACEHOLDER": "es. Tavolo 12",
    "TABLE_NUMBER": "Numero tavolo",
    "TABLE_NUMBER_PLACEHOLDER": "es. 1, A1, VIP-1",
    "TABLE_DISPLAY_NAME": "Nome visualizzato",
    "TABLE_DISPLAY_NAME_PLACEHOLDER": "Come appare in grande sulla planimetria",
    "TABLE_CODE_AUTO_HINT": "Un codice univoco (es. T-001) viene assegnato automaticamente alla creazione e non è modificabile.",
    "TABLE_CODE_LABEL": "Codice",
    "TABLE_COLOR": "Colore tavolo",
    "TABLE_SEATS_LABEL": "Coperti (numero)",
    "MIN_SEATS": "Coperti minimi",
    "MIN_SEATS_INVALID": "I coperti minimi non possono superare i coperti.",
    "TABLE_SHAPE_LABEL": "Forma tavolo",
    "ADD_TABLE": "Aggiungi tavolo",
    "DECORATIONS_TITLE": "Decorazioni (in arrivo)",
    "DECORATIONS_HINT": "Piante, muri e colonne saranno disponibili in questa sezione.",
    "SHAPE_ROUND": "Rotondo",
    "SHAPE_SQUARE": "Quadrato",
    "SHAPE_RECTANGLE": "Rettangolare",
    "SHAPE_RECTANGLE_SHORT": "Rett",
    "NO_TABLES": "Nessun tavolo in questa sala",
    "NO_TABLES_MATCH_SEARCH": "Nessun tavolo corrisponde alla ricerca.",
    "CREATE_COMBINATION": "Crea combinazione",
    "STATUS_FREE": "Libero",
    "STATUS_RESERVED": "Prenotato",
    "STATUS_OCCUPIED": "Occupato",
    "STATUS_BLOCKED": "Bloccato",
    "ROOM_CREATED": "Sala creata con successo.",
    "ROOM_DELETED": "Sala eliminata con successo.",
    "TABLE_CREATED": "Tavolo creato con successo.",
    "TABLE_UPDATED": "Tavolo aggiornato con successo.",
    "TABLE_DELETED": "Tavolo eliminato con successo.",
    "DELETE_TABLE_CONFIRM_TITLE": "Elimina tavolo",
    "DELETE_TABLE_CONFIRM_MESSAGE": "Sei sicuro di voler eliminare il tavolo {{name}}?",
    "COMBINATION_CREATED": "Combinazione creata con successo.",
    "COMBINATION_DELETED": "Combinazione eliminata con successo.",
    "ERROR_LOAD_ROOMS": "Impossibile caricare le sale.",
    "ERROR_CREATE_ROOM": "Impossibile creare la sala.",
    "ERROR_UPDATE_ROOM": "Impossibile aggiornare la sala.",
    "ERROR_DELETE_ROOM": "Impossibile eliminare la sala.",
    "ERROR_LOAD_TABLES": "Impossibile caricare i tavoli.",
    "ERROR_LOAD_COMBINATIONS": "Impossibile caricare le combinazioni tavoli.",
    "ERROR_LOAD_ROOM_LAYOUT": "Impossibile caricare il layout della sala (tavoli, combinazioni o componenti).",
    "ERROR_CREATE_COMPONENT": "Impossibile creare il componente di layout.",
    "ERROR_UPDATE_COMPONENT": "Impossibile aggiornare il componente di layout.",
    "ERROR_DELETE_COMPONENT": "Impossibile eliminare il componente di layout.",
    "ERROR_CREATE_TABLE": "Impossibile creare il tavolo.",
    "ERROR_UPDATE_TABLE": "Impossibile aggiornare il tavolo.",
    "ERROR_DELETE_TABLE": "Impossibile eliminare il tavolo.",
    "ERROR_CREATE_COMBINATION": "Impossibile creare la combinazione.",
    "COMBINATIONS_TITLE": "Combinazioni tavoli",
    "COMBINATIONS_EMPTY": "Nessuna combinazione in questa sala. In modalità modifica usa Ctrl+clic (⌘ su Mac) sui tavoli per selezionarli, poi aggiungi una combinazione.",
    "COMBINATION_NEW_TITLE": "Nuova combinazione",
    "COMBINATION_EDIT_TITLE": "Modifica combinazione",
    "COMBINATION_NAME": "Nome combinazione",
    "COMBINATION_NAME_PLACEHOLDER": "es. Banchetto A, Gruppo numeroso",
    "COMBINATION_DISPLAY_NAME": "Nome visualizzato",
    "COMBINATION_DISPLAY_NAME_PLACEHOLDER": "Come appare in elenco e in evidenza sulla planimetria",
    "COMBINATION_CODE_AUTO_HINT": "Un codice univoco (es. C-001) viene assegnato automaticamente alla creazione e non è modificabile.",
    "COMBINATION_CODE_LABEL": "Codice",
    "COMBINATION_COLOR": "Colore combinazione",
    "COMBINATION_MIN_PARTY": "Ospiti minimi (coperti)",
    "COMBINATION_MAX_PARTY": "Ospiti massimi (coperti)",
    "COMBINATION_PARTY_HINT": "Coperti prenotabili per questa combinazione — non legati alla somma dei posti dei tavoli. Valori ammessi: 1–99 per min e max.",
    "COMBINATION_BOOKABLE_RANGE": "Prenotazioni {{min}}–{{max}} ospiti",
    "COMBINATION_PARTY_MIN_MAX_INVALID": "I coperti minimi non possono essere maggiori dei massimi.",
    "COMBINATION_PARTY_BOUNDS_INVALID": "Min e max ospiti devono essere tra 1 e 99.",
    "COMBINATION_PARTY_CAPACITY_INVALID": "Il range ospiti deve essere tra 1 e {{cap}} (posti totali dei tavoli selezionati).",
    "ERROR_COMBINATION_PARTY_MIN": "I coperti minimi devono essere tra 1 e 99.",
    "ERROR_COMBINATION_PARTY_MAX": "I coperti massimi devono essere tra 1 e 99.",
    "ERROR_COMBINATION_PARTY_CAPACITY": "Il range coperti non può superare i posti totali della combinazione.",
    "ERROR_COMBINATION_PARTY_MAX_BOUND": "Min e max ospiti non possono superare 99.",
    "ERROR_COMBINATION_MIN_SEATS": "La combinazione deve avere almeno 2 posti totali.",
    "COMBINATION_TABLES_PICK": "Tavoli in sala",
    "COMBINATION_TOTAL_SEATS_PREVIEW": "Coperti totali (anteprima)",
    "COMBINATION_USE_CANVAS_SELECTION": "Usa selezione sul canvas",
    "COMBINATION_USE_CANVAS_SELECTION_EDIT_MODE": "Attiva “Modifica layout” per selezionare più tavoli sul piano (Ctrl+clic, ⌘ su Mac), poi usa questo pulsante.",
    "COMBINATION_NEED_TWO_TABLES": "Seleziona almeno due tavoli.",
    "COMBINATION_NON_COMBINABLE_NOTE": "Non combinabile — abilita nel pannello tavolo.",
    "COMBINATION_SAVE": "Salva combinazione",
    "COMBINATION_UPDATED": "Combinazione aggiornata con successo.",
    "TABLE_COMBINABLE": "Tavolo combinabile",
    "TABLE_COMBINABLE_HINT": "Solo i tavoli combinabili possono essere raggruppati in una combinazione nominata per le prenotazioni.",
    "DELETE_COMBINATION_CONFIRM_TITLE": "Elimina combinazione",
    "DELETE_COMBINATION_CONFIRM_MESSAGE": "Eliminare la combinazione {{name}}? I tavoli restano in sala.",
    "MULTI_SELECT_HINT": "In modalità modifica: Ctrl+clic (⌘ su Mac) su un tavolo per aggiungerlo o toglierlo dalla selezione. Utile per costruire combinazioni.",
    "MULTI_SELECT_HINT_SHORT": "Ctrl+clic (⌘) sul tavolo: selezione multipla",
    "COMBINATION_BADGE_TOOLTIP": "In {{count}} combinazione/i",
    "COMBINATION_HIGHLIGHT_ON_PLAN": "Evidenzia questi tavoli in planimetria (clic di nuovo per disattivare)",
    "ERROR_COMBINATION_DUPLICATE_NAME": "Esiste già una combinazione con questo nome in questa sala.",
    "ERROR_COMBINATION_MIN_TABLES": "La combinazione deve includere almeno due tavoli distinti.",
    "ERROR_COMBINATION_INVALID_TABLES": "Alcuni tavoli non sono validi o appartengono a un'altra sala.",
    "ERROR_COMBINATION_NOT_COMBINABLE": "Uno o più tavoli non sono combinabili.",
    "ERROR_COMBINATION_BOOKINGS": "Operazione bloccata: ci sono prenotazioni future collegate a questa sala o a questi tavoli.",
    "RESIZE_TABLE": "Ridimensiona tavolo",
    "RESIZE_COMPONENT": "Ridimensiona componente",
    "SNAP_GRID_ON": "Griglia magnetica: attiva",
    "SNAP_GRID_OFF": "Griglia magnetica: disattiva",
    "NO_CLIP_ON": "No clip: attivo — tavoli e componenti possono sovrapporsi (restano i bordi del canvas). Disattiva a fine ridisegno.",
    "NO_CLIP_OFF": "No clip: disattivo — distanza solo tra tavoli; i componenti di layout possono sovrapporsi tra loro e ai tavoli.",
    "ADVANCED": "Avanzate",
    "ADVANCED_ARIA": "Opzioni di layout avanzate",
    "ADVANCED_SNAP": "Griglia magnetica",
    "ADVANCED_NO_CLIP": "No clip",
    "CANVAS_SHRINK_WIDTH": "Riduci larghezza canvas",
    "CANVAS_GROW_WIDTH": "Aumenta larghezza canvas",
    "CANVAS_SHRINK_HEIGHT": "Riduci altezza canvas",
    "CANVAS_GROW_HEIGHT": "Aumenta altezza canvas",
    "CANVAS_WIDTH": "Larghezza canvas",
    "CANVAS_HEIGHT": "Altezza canvas",
    "LIVE_TITLE": "Sala (live)",
    "LIVE_SUBTITLE": "Sala live — tocca un tavolo per prenotare, segnare l’arrivo o bloccare. I colori seguono prenotazioni e ora attuale.",
    "LIVE_TAB_FLOOR": "Planimetria",
    "LIVE_TAB_LIST": "Lista prenotazioni",
    "LIVE_TAB_ELENCO": "Elenco",
    "LIVE_VIEW_TABS_ARIA": "Scegli la vista: planimetria o elenco",
    "LIVE_ACTIONS_ARIA": "Azioni prenotazione: prenotazione automatica e ricerca prenotazioni",
    "LIVE_LIST_HEADING": "Prenotazioni",
    "LIVE_LIST_HINT": "Tocca una riga per aprire il tavolo e gestire la prenotazione. Cambia la data nella colonna a sinistra.",
    "LIVE_LIST_EMPTY_ROOM": "Nessuna prenotazione per questa sala nella data selezionata.",
    "LIVE_LIST_TIMELINE_LEGEND": "Fascia nella giornata ({{start}}–{{end}})",
    "LIVE_LIST_ROW_ARIA": "{{start}}–{{end}}, {{title}}, {{place}}{{codePart}}. Apri tavolo.",
    "LIVE_LIST_PLACEMENT_TABLE": "Tavolo {{name}}",
    "LIVE_LIST_PLACEMENT_COMBO": "Combinazione {{name}}",
    "LIVE_LIST_TABLE_CAPTION": "Tavolo",
    "LIVE_LIST_TABLE_COMBO_DETAIL": "{{combo}} — {{tables}}",
    "LIVE_LIST_TABLE_UNSPECIFIED": "Non assegnato",
    "LIVE_LIST_PLACEMENT_UNSPEC": "Postazione non indicata",
    "LIVE_LIST_OPEN_ERROR": "Impossibile aprire un tavolo per questa prenotazione.",
    "LIVE_BOOKING_CODE": "Codice prenotazione",
    "LIVE_SEARCH_LABEL": "Cerca",
    "LIVE_SEARCH_PLACEHOLDER": "Tavolo, combinazione, codice prenotazione, titolo o ospite…",
    "LIVE_SEARCH_CLEAR": "Azzera ricerca",
    "LIVE_LIST_SEARCH_EMPTY": "Nessuna prenotazione corrisponde alla ricerca. Prova un altro tavolo, nome o codice prenotazione.",
    "LIVE_FLOOR_SEARCH_EMPTY": "Nessun tavolo in questa sala corrisponde alla ricerca. Azzera la ricerca o prova un altro nome o codice prenotazione.",
    "LIVE_DATE": "Data",
    "LIVE_REFRESH": "Aggiorna",
    "LIVE_ROOM_LAYOUT_LOADING": "Caricamento planimetria sala…",
    "LIVE_TABLE_SHEET_TITLE": "Tavolo {{name}}",
    "LIVE_ADD_RESERVATION": "Aggiungi prenotazione",
    "LIVE_ADD_WALKIN": "Aggiungi walk-in / occupato",
    "LIVE_RESERVE_TABLE": "Prenota",
    "LIVE_AUTO_RES_OPEN": "Prenota automaticamente",
    "LIVE_AUTO_RES_TITLE": "Prenotazione automatica",
    "LIVE_AUTO_RES_HINT": "Inserisci dati e cerca un tavolo disponibile best-fit nelle sale selezionate.",
    "LIVE_AUTO_RES_DATE": "Data prenotazione",
    "LIVE_AUTO_RES_DATE_INVALID": "Seleziona una data di prenotazione valida.",
    "LIVE_AUTO_RES_ROOMS": "Sale dove cercare",
    "LIVE_AUTO_RES_ROOMS_PLACEHOLDER": "Seleziona sale",
    "LIVE_AUTO_RES_ROOMS_REQUIRED": "Seleziona almeno una sala.",
    "LIVE_AUTO_RES_FIND": "Cerca tavolo",
    "LIVE_AUTO_RES_FOUND": "Postazione suggerita",
    "LIVE_AUTO_RES_FOUND_TABLE": "Tavolo: {{table}}",
    "LIVE_AUTO_RES_FOUND_COMBO": "Combinazione tavoli: {{name}}",
    "LIVE_AUTO_RES_FOUND_COMBO_TABLES": "Tavoli: {{tables}}",
    "LIVE_AUTO_RES_FOUND_ROOM": "Sala: {{room}}",
    "LIVE_AUTO_RES_FOUND_TIME": "Orario: {{start}}-{{end}}",
    "LIVE_AUTO_RES_CONFIRM": "Conferma prenotazione",
    "LIVE_AUTO_RES_FIND_ANOTHER": "Cerca un altro tavolo",
    "LIVE_AUTO_RES_NO_TABLE": "Nessun tavolo disponibile con questi criteri.",
    "LIVE_AUTO_RES_NO_MORE_TABLES": "Non ci sono altri tavoli alternativi.",
    "LIVE_AUTO_RES_LOOKUP_ERROR": "Impossibile cercare i tavoli disponibili.",
    "LIVE_AUTO_RES_SUMMARY_TITLE": "Prenotazione confermata",
    "LIVE_AUTO_RES_SUMMARY_TABLE": "Tavolo: {{table}}",
    "LIVE_AUTO_RES_SUMMARY_COMBO": "Combinazione: {{name}}",
    "LIVE_AUTO_RES_SUMMARY_COMBO_TABLES": "Tavoli: {{tables}}",
    "LIVE_AUTO_RES_SUMMARY_ROOM": "Sala: {{room}}",
    "LIVE_AUTO_RES_SUMMARY_TIME": "Orario: {{start}}-{{end}}",
    "LIVE_AUTO_RES_SUMMARY_GUEST": "Ospite: {{guest}}",
    "LIVE_GLOBAL_RES_OPEN": "Cerca prenotazione",
    "LIVE_GLOBAL_RES_TITLE": "Ricerca prenotazioni",
    "LIVE_GLOBAL_RES_HINT": "Cerca per codice prenotazione, nome ospite o nome tavolo/combinazione. Include tutte le date e gli stati (anche chiuse e al tavolo).",
    "LIVE_GLOBAL_RES_FIELD_LABEL": "Testo di ricerca",
    "LIVE_GLOBAL_RES_PLACEHOLDER": "Codice, nome ospite, tavolo…",
    "LIVE_GLOBAL_RES_SEARCH": "Cerca",
    "LIVE_GLOBAL_RES_OPEN_HINT": "Tocca per aprire il tavolo nella data della prenotazione.",
    "LIVE_GLOBAL_RES_EMPTY": "Nessuna prenotazione trovata.",
    "LIVE_GLOBAL_RES_INITIAL": "Inserisci almeno 2 caratteri e premi Cerca.",
    "LIVE_GLOBAL_RES_QUERY_SHORT": "Inserisci almeno 2 caratteri.",
    "LIVE_GLOBAL_RES_ERROR": "Ricerca non riuscita. Riprova.",
    "LIVE_GLOBAL_RES_OPEN_NO_TABLE": "Impossibile aprire: nessun tavolo associato a questa prenotazione.",
    "LIVE_BLOCK_TABLE": "Blocca tavolo",
    "LIVE_UNBLOCK_TABLE": "Sblocca tavolo",
    "LIVE_RELEASE_DAY": "Annulla tutte le prenotazioni (giorno)",
    "LIVE_MARK_SEATED": "Cliente arrivato",
    "LIVE_MARK_SEATED_SUCCESS": "Segnato come al tavolo.",
    "LIVE_MARK_SEATED_ERROR": "Impossibile aggiornare l’arrivo.",
    "LIVE_RELEASE_TABLE_EARLY": "Libera tavolo — ospiti usciti prima della fine della prenotazione",
    "LIVE_RELEASE_TABLE_EARLY_TITLE": "Libera tavolo",
    "LIVE_RELEASE_TABLE_EARLY_SUB": "Ospiti usciti · chiude la fascia ora",
    "LIVE_RELEASE_EARLY_SUCCESS": "Tavolo liberato. Prenotazione chiusa con l’orario di fine impostato.",
    "LIVE_RELEASE_EARLY_ERROR": "Impossibile liberare il tavolo.",
    "LIVE_RELEASE_CHOICE_TITLE": "Tavolo occupato",
    "LIVE_RELEASE_CHOICE_BODY": "Gli ospiti sono usciti? Chiudi la prenotazione impostando come fine l’ora attuale. Oppure, se hai segnato l’arrivo per errore, annulla solo l’arrivo: la prenotazione resta confermata come prima.",
    "LIVE_RELEASE_CHOICE_UNDO": "Annulla arrivo (non al tavolo)",
    "LIVE_RELEASE_CHOICE_CLOSE": "Ospiti usciti — chiudi prenotazione",
    "LIVE_UNDO_ARRIVAL_SUCCESS": "Arrivo annullato. La prenotazione è di nuovo solo riservata.",
    "LIVE_UNDO_ARRIVAL_ERROR": "Impossibile annullare l’arrivo.",
    "LIVE_GUEST_SEATED_BADGE": "Al tavolo",
    "LIVE_RES_COMBO_BADGE": "Combinazione",
    "LIVE_RES_PARTIAL_BADGE": "Posto parziale",
    "LIVE_RES_PLACEMENT_MISSING": "Posto non in planimetria",
    "LIVE_VISUAL_BLOCKED": "Bloccato",
    "LIVE_VISUAL_FREE": "Disponibile (ora)",
    "LIVE_VISUAL_WAITING": "Prenotato — in attesa",
    "LIVE_VISUAL_SEATED": "Ospiti al tavolo",
    "LIVE_VISUAL_DAY_BOOKED": "Ha prenotazioni (questo giorno)",
    "LIVE_CANCEL_RESERVATION": "Annulla questa prenotazione",
    "LIVE_CANCEL_RESERVATION_SUCCESS": "Prenotazione annullata.",
    "LIVE_CANCEL_RESERVATION_ERROR": "Impossibile annullare la prenotazione.",
    "LIVE_EDIT_RESERVATION": "Modifica prenotazione",
    "LIVE_EDIT_RESERVATION_TITLE": "Modifica prenotazione",
    "LIVE_EDIT_RESERVATION_HINT": "Scegli prima il giorno, poi l’orario in base alla disponibilità. Puoi aggiornare anche coperti e note. Con il cliente al tavolo sono modificabili solo le note.",
    "LIVE_EDIT_RES_DATE": "Data prenotazione",
    "LIVE_EDIT_RES_DATE_HINT": "Dopo aver cambiato il giorno, gli orari di inizio disponibili si aggiornano automaticamente.",
    "LIVE_EDIT_START_INVALID_FOR_DATE": "Scegli un orario di inizio tra quelli disponibili per il giorno selezionato (o modifica data o coperti e riprova).",
    "LIVE_EDIT_GUEST_SEATED_HINT": "Il cliente è al tavolo: puoi aggiornare solo le note. Per cambiare orario o tavolo, libera prima il tavolo.",
    "LIVE_EDIT_SUCCESS": "Prenotazione aggiornata.",
    "LIVE_EDIT_ERROR": "Impossibile aggiornare la prenotazione.",
    "LIVE_EDIT_NO_CHANGES": "Nessuna modifica da salvare.",
    "LIVE_MOVE_RESERVATION": "Sposta su altro tavolo",
    "LIVE_MOVE_RESERVATION_TITLE": "Sposta prenotazione",
    "LIVE_MOVE_RESERVATION_HINT": "Scegli un altro tavolo in qualsiasi sala. Stesso orario e durata (deve essere libero, incluse le prenotazioni combo).",
    "LIVE_MOVE_RESERVATION_HINT_COMBO": "Scegli un'altra combinazione o un tavolo singolo in qualsiasi sala. Stesso orario e durata; tutti i tavoli della destinazione devono essere liberi.",
    "LIVE_MOVE_TARGET_DESTINATION": "Destinazione",
    "LIVE_MOVE_TARGET_REQUIRED": "Seleziona una destinazione.",
    "LIVE_MOVE_OPTION_COMBO_TITLE": "{{name}} — combo · {{seats}} posti",
    "LIVE_MOVE_OPTION_COMBO_SUB": "{{room}} · {{slot}} · {{party}} coperti · Tavoli: {{tables}}",
    "LIVE_MOVE_OPTION_TITLE": "{{name}} — max {{seats}} posti",
    "LIVE_MOVE_OPTION_SUB": "{{room}} · Fascia {{slot}} · {{party}} coperti (compatibile)",
    "LIVE_MOVE_TARGETS_LOADING": "Ricerca tavoli disponibili per questa fascia…",
    "LIVE_MOVE_TARGETS_ERROR": "Impossibile caricare i tavoli per lo spostamento.",
    "LIVE_MOVE_SEARCH_PLACEHOLDER": "Cerca per nome tavolo o sala…",
    "LIVE_MOVE_TARGET_TABLE": "Tavolo di destinazione",
    "LIVE_MOVE_SUBMIT": "Sposta",
    "LIVE_MOVE_SUCCESS": "Prenotazione spostata.",
    "LIVE_MOVE_ERROR": "Impossibile spostare la prenotazione.",
    "LIVE_MOVE_TABLE_REQUIRED": "Seleziona un tavolo di destinazione.",
    "LIVE_MOVE_NO_TARGETS": "Nessun altro tavolo compatibile in nessuna sala: posti sufficienti e fascia libera per questo orario.",
    "LIVE_MOVE_NO_TARGETS_COMBO": "Nessuna altra combinazione o tavolo compatibile in nessuna sala: coperti ammessi e fascia libera su tutti i tavoli coinvolti.",
    "LIVE_MOVE_NO_TARGETS_ONLY_ONE_COMBO": "Nel locale c'è solo la combinazione attuale «{{comboName}}» in sala «{{room}}» ({{totalSeats}} posti fisici). Per spostare {{party}} coperti crea un'altra combinazione (anche in un'altra sala) dall'editor planimetria. I tavoli singoli hanno al massimo {{maxTableSeats}} posti ciascuno.",
    "LIVE_RESERVATIONS": "Prenotazioni",
    "LIVE_RES_COVERS": "{{count}} coperti",
    "LIVE_RES_FINISHED": "Conclusa",
    "LIVE_RES_FINISHED_NOTE": "Chiusa · fascia {{start}}–{{end}}",
    "LIVE_RESERVATIONS_BADGE": "pren.",
    "LIVE_NO_RESERVATIONS": "Nessuna prenotazione per questo giorno.",
    "LIVE_COMBINATIONS": "Combinazioni",
    "LIVE_COMBOS_SHORT": "combo",
    "LIVE_TABLE_SEATS_TOOLTIP": "{{count}} coperti",
    "LIVE_TABLE_RES_TOOLTIP": "{{count}} prenotazioni per oggi",
    "LIVE_STATUS_ACTIONS": "Stato tavolo",
    "LIVE_STATUS_LABEL": "Stato",
    "LIVE_CYCLE_STATUS": "Stato successivo",
    "LIVE_FREE_CONFIRM_TITLE": "Annullare le prenotazioni?",
    "LIVE_FREE_CONFIRM_BODY": "Il tavolo {{name}} ha prenotazioni per questo giorno. Impostarlo su Libero e annullare quelle prenotazioni? L’operazione non è reversibile da qui.",
    "LIVE_FREE_CONFIRM_SUBMIT": "Annulla prenotazioni e imposta Libero",
    "LIVE_FREE_CONFIRM_BACK": "Mantieni lo stato attuale",
    "LIVE_FREE_SUCCESS": "Prenotazioni annullate e tavolo impostato su Libero.",
    "LIVE_FREE_ERROR": "Impossibile liberare il tavolo.",
    "LIVE_NOTES": "Note staff",
    "LIVE_ERROR_LOAD": "Impossibile caricare la vista live.",
    "LIVE_OPEN_EDITOR": "Apri editor planimetria",
    "MANUAL_RES_TITLE": "Prenotazione tavolo — {{status}}",
    "MANUAL_RES_TITLE_RESERVE": "Nuova prenotazione tavolo",
    "MANUAL_RES_HINT": "Crea una prenotazione con orario per l’ospite. I colori in sala live dipendono dalle prenotazioni e dall’ora corrente.",
    "MANUAL_RES_START": "Orario",
    "MANUAL_RES_END": "Ora fine (opzionale)",
    "MANUAL_RES_END_HINT": "Lascia vuoto per usare la durata predefinita dalle impostazioni chatbot/sala.",
    "MANUAL_RES_DURATION_HINT": "L’orario di fine è calcolato automaticamente dalla durata prenotazione impostata.",
    "MANUAL_RES_SLOTS_LOADING": "Caricamento orari disponibili…",
    "MANUAL_RES_SLOTS_EMPTY": "Nessun orario prenotabile per questo giorno, numero coperti o tavolo. Controlla impostazioni ristorante o disponibilità.",
    "MANUAL_RES_SLOTS_LOAD_ERROR": "Impossibile caricare gli orari prenotabili.",
    "MANUAL_RES_PARTY": "Numero coperti",
    "MANUAL_RES_COMBO_SELECT": "Combinazione tavoli",
    "MANUAL_RES_COMBO_SINGLE_HINT": "La prenotazione usa la combinazione «{{name}}» (restano impegnati tutti i tavoli collegati in quella fascia).",
    "MANUAL_RES_NOTES": "Note (opzionale)",
    "MANUAL_RES_GUEST_CONTACT": "Ospite / contatto",
    "MANUAL_RES_GUEST_PLACEHOLDER": "Scegli un contatto o senza nominativo",
    "MANUAL_RES_SEARCH_CONTACTS": "Cerca contatti…",
    "MANUAL_RES_CREATE_CONTACT": "+ Nuovo contatto",
    "MANUAL_RES_NO_CONTACT": "Senza nominativo / walk-in",
    "MANUAL_RES_FILL_GUEST": "Seleziona un contatto o senza nominativo.",
    "MANUAL_RES_WALK_IN_DISPLAY": "Walk-in (senza contatto)",
    "MANUAL_RES_CONTACT_MODE": "Ospite",
    "MANUAL_RES_EXISTING": "Contatto esistente",
    "MANUAL_RES_NEW": "Nuovo contatto",
    "MANUAL_RES_SELECT_CONTACT": "Seleziona contatto",
    "MANUAL_RES_FIRST": "Nome",
    "MANUAL_RES_LAST": "Cognome",
    "MANUAL_RES_PHONE": "Telefono",
    "MANUAL_RES_EMAIL": "Email (opzionale)",
    "MANUAL_RES_SUBMIT": "Salva prenotazione",
    "MANUAL_RES_CANCEL": "Annulla",
    "MANUAL_RES_FILL_CONTACT": "Seleziona un contatto.",
    "MANUAL_RES_FILL_NEW": "Nome, cognome e telefono sono obbligatori.",
    "MANUAL_RES_START_REQUIRED": "Seleziona un orario.",
    "MANUAL_RES_SUCCESS": "Prenotazione salvata.",
    "MANUAL_RES_ERROR": "Impossibile salvare la prenotazione.",
    "MANUAL_RES_CONTACTS_LOAD_ERROR": "Impossibile caricare i contatti.",
    "LIVE_APPT_STATUS_CONFIRMED": "Confermato",
    "LIVE_APPT_STATUS_PENDING": "In attesa",
    "LIVE_APPT_STATUS_COMPLETED": "Completato",
    "LIVE_APPT_STATUS_CANCELLED": "Annullato",
    "LIVE_APPT_STATUS_CANCELLED_BY_CLIENT": "Annullato dal cliente",
    "LIVE_APPT_STATUS_NO_SHOW": "Assente",
    "ANALYTICS_TITLE": "Analytics sala",
    "ANALYTICS_SUBTITLE": "Prenotazioni e utilizzo tavoli nel periodo selezionato (date UTC).",
    "ANALYTICS_FROM": "Da",
    "ANALYTICS_TO": "A",
    "ANALYTICS_PRESET_7D": "Ultimi 7 giorni",
    "ANALYTICS_PRESET_30D": "Ultimi 30 giorni",
    "ANALYTICS_APPLY": "Applica",
    "ANALYTICS_LOADING": "Caricamento analytics…",
    "ANALYTICS_ERROR": "Impossibile caricare le analytics. Controlla l’intervallo di date e riprova.",
    "ANALYTICS_KPI_TOTAL": "Prenotazioni totali",
    "ANALYTICS_KPI_WITH_TABLE": "Con tavolo assegnato",
    "ANALYTICS_KPI_WITH_COMBO": "Con combinazione tavoli",
    "ANALYTICS_KPI_CONFIRMED": "Confermate",
    "ANALYTICS_KPI_NO_SHOW": "Assenti",
    "ANALYTICS_KPI_CANCELLED": "Annullate (tutte)",
    "ANALYTICS_CHART_BOOKINGS": "Prenotazioni per giorno",
    "ANALYTICS_CHART_STATUS": "Per stato",
    "ANALYTICS_CHART_HOUR": "Prenotazioni per ora (inizio)",
    "ANALYTICS_CHART_TOP_TABLES": "Tavoli più usati",
    "ANALYTICS_CHART_DAY_STATUS": "Stato operativo tavoli per giorno",
    "ANALYTICS_TOP_TABLES": "Tavoli più usati",
    "ANALYTICS_TOP_ROOMS": "Sale più usate",
    "ANALYTICS_RECENT": "Prenotazioni recenti",
    "ANALYTICS_UNFULFILLED_TITLE": "Chat: richieste tavolo non soddisfatte",
    "ANALYTICS_UNFULFILLED_HINT": "Registrate quando il chatbot non trova tavolo dopo l’orario richiesto e ±30 minuti.",
    "ANALYTICS_UNFULFILLED_EMPTY": "Nessuna richiesta chat non soddisfatta.",
    "ANALYTICS_UNFULFILLED_COL_WHEN": "Registrata il",
    "ANALYTICS_UNFULFILLED_COL_PARTY": "Coperti",
    "ANALYTICS_UNFULFILLED_COL_OFFSETS": "Offset provati (min)",
    "ANALYTICS_NO_DATA": "Nessun dato per questo periodo.",
    "ANALYTICS_COL_TABLE": "Tavolo",
    "ANALYTICS_COL_ROOM": "Sala",
    "ANALYTICS_COL_COUNT": "Conteggio",
    "ANALYTICS_COL_DATE": "Data",
    "ANALYTICS_COL_TIME": "Orario",
    "ANALYTICS_COL_TITLE": "Titolo",
    "ANALYTICS_COL_STATUS": "Stato"
  }
}
